// This file is auto-generated by @hey-api/openapi-ts

export const $Action = {
    type: 'string',
    enum: ['Buy', 'Sell']
} as const;

export const $ArbitrageEnforcementResult = {
    type: 'object',
    description: 'Arbitrage enforcement result.',
    required: ['calendar_adjustments', 'butterfly_adjustments', 'butterfly_violations', 'post_enforcement_butterfly_clean', 'post_enforcement_calendar_clean', 'post_enforcement_composite'],
    properties: {
        butterfly_adjustments: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        },
        butterfly_violations: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        },
        calendar_adjustments: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        },
        post_enforcement_butterfly_clean: {
            type: 'boolean',
            description: 'True if `check_arbitrage()` returns butterfly_clean after enforcement.'
        },
        post_enforcement_calendar_clean: {
            type: 'boolean',
            description: 'True if `check_arbitrage()` returns calendar_clean after enforcement.'
        },
        post_enforcement_composite: {
            type: 'number',
            format: 'double',
            description: 'Composite quality score (0.0 = all violations, 1.0 = clean) after enforcement.'
        }
    }
} as const;

export const $ArbitrageQuality = {
    type: 'object',
    description: `Quality metrics for an IVSurface (arbitrage-free check).
Note: Different from \`FitQuality\` in volatility_surface.rs (SVI fit quality).
This struct is about ARBITRAGE quality, not SVI fit quality.`,
    required: ['butterfly_clean', 'calendar_clean', 'composite'],
    properties: {
        butterfly_clean: {
            type: 'boolean',
            description: 'true if no butterfly arbitrage detected in any expiration'
        },
        calendar_clean: {
            type: 'boolean',
            description: 'true if total variance is monotonic across expirations'
        },
        composite: {
            type: 'number',
            format: 'double',
            description: '1.0 = perfect, lower = more violations'
        }
    }
} as const;

export const $AssistantTool = {
    type: 'object',
    required: ['type', 'function'],
    properties: {
        function: {
            '$ref': '#/components/schemas/AssistantToolFunction'
        },
        type: {
            type: 'string'
        }
    }
} as const;

export const $AssistantToolFunction = {
    type: 'object',
    required: ['name', 'description'],
    properties: {
        description: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        parameters: {
            description: 'a JSON Schema'
        }
    }
} as const;

export const $AtmTenorBacktestRow = {
    type: 'object',
    description: 'A single row in the ATM tenor backtest results.',
    required: ['as_of_date', 'future_date', 'hold_days', 'target_tenor', 'current_atm_iv', 'projected_atm_iv', 'realized_atm_iv', 'projected_error', 'unchanged_error', 'beats_unchanged'],
    properties: {
        as_of_date: {
            type: 'string'
        },
        beats_unchanged: {
            type: 'boolean'
        },
        current_atm_iv: {
            type: 'number',
            format: 'double'
        },
        future_date: {
            type: 'string'
        },
        hold_days: {
            type: 'integer',
            format: 'int32'
        },
        projected_atm_iv: {
            type: 'number',
            format: 'double'
        },
        projected_error: {
            type: 'number',
            format: 'double'
        },
        realized_atm_iv: {
            type: 'number',
            format: 'double'
        },
        target_tenor: {
            type: 'integer',
            format: 'int32'
        },
        unchanged_error: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $AtmTenorBacktestSummary = {
    type: 'object',
    description: 'Aggregate ATM tenor backtest summary.',
    required: ['tenors', 'target_tenors'],
    properties: {
        target_tenors: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int32'
            }
        },
        tenors: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AtmTenorSummary'
            }
        }
    }
} as const;

export const $AtmTenorSummary = {
    type: 'object',
    description: 'Per-tenor aggregate statistics for ATM backtest.',
    required: ['tenor', 'rows', 'projected_mae', 'unchanged_mae', 'model_beat_count', 'total_rows'],
    properties: {
        model_beat_count: {
            type: 'integer',
            minimum: 0
        },
        projected_mae: {
            type: 'number',
            format: 'double'
        },
        rows: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AtmTenorBacktestRow'
            }
        },
        tenor: {
            type: 'integer',
            format: 'int32'
        },
        total_rows: {
            type: 'integer',
            minimum: 0
        },
        unchanged_mae: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $BoundsSpec = {
    type: 'object',
    properties: {
        breakeven_max: {
            type: ['number', 'null'],
            format: 'double'
        },
        breakeven_min: {
            type: ['number', 'null'],
            format: 'double'
        },
        greeks: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/GreeksBounds'
                }
            ]
        },
        min_pop: {
            type: ['number', 'null'],
            format: 'double'
        },
        min_reward_to_risk: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $CandidateExpiration = {
    type: 'object',
    description: 'Single expiration in the candidate table.',
    required: ['date', 'dte', 'atm_iv', 'candidates'],
    properties: {
        atm_iv: {
            type: 'number',
            format: 'double'
        },
        candidates: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/RankedCandidate'
            }
        },
        date: {
            type: 'string'
        },
        dte: {
            type: 'integer',
            format: 'int32'
        }
    }
} as const;

export const $CandidateTable = {
    type: 'object',
    description: 'Candidate table for a specific strategy type.',
    required: ['strategy_name', 'vol_type', 'stock_price', 'chain_atm_iv', 'chain_median_iv', 'expirations'],
    properties: {
        chain_atm_iv: {
            type: 'number',
            format: 'double'
        },
        chain_median_iv: {
            type: 'number',
            format: 'double'
        },
        expirations: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CandidateExpiration'
            }
        },
        stock_price: {
            type: 'number',
            format: 'double'
        },
        strategy_name: {
            type: 'string'
        },
        vol_type: {
            type: 'string'
        }
    }
} as const;

export const $CandleField = {
    type: 'string',
    enum: ['delta', 'price', 'size']
} as const;

export const $CandleFilter = {
    type: 'string',
    enum: ['all', 'next_exp', 'retail']
} as const;

export const $CandleOption = {
    type: 'string',
    enum: ['total', 'call', 'put']
} as const;

export const $CandleTOHLCV = {
    type: 'object',
    required: ['time', 'open', 'high', 'low', 'close', 'volume'],
    properties: {
        close: {
            type: 'number',
            format: 'double'
        },
        high: {
            type: 'number',
            format: 'double'
        },
        low: {
            type: 'number',
            format: 'double'
        },
        open: {
            type: 'number',
            format: 'double'
        },
        time: {
            type: 'integer',
            format: 'int64',
            description: 'unix timestamp in milliseconds'
        },
        volume: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $CandlesRsp = {
    type: 'object',
    required: ['symbol', 'candles'],
    properties: {
        candles: {
            type: 'array',
            items: {
                type: 'array',
                items: false,
                prefixItems: [
                    {
                        type: 'integer',
                        format: 'int64'
                    },
                    {
                        type: 'number',
                        format: 'double'
                    },
                    {
                        type: 'number',
                        format: 'double'
                    },
                    {
                        type: 'number',
                        format: 'double'
                    },
                    {
                        type: 'number',
                        format: 'double'
                    },
                    {
                        type: 'number',
                        format: 'double'
                    }
                ]
            },
            description: `An array of candle tuples with fields ordered as
(Timestamp, Open, High, Low, Close, Volume)`
        },
        symbol: {
            type: 'string'
        }
    }
} as const;

export const $CarryCost = {
    type: 'object',
    required: ['theta_daily', 'theta_weekly', 'theta_total', 'theta_instantaneous_daily', 'decay_to_expiry_cap', 'div_yield', 'forward_price', 'total_carry'],
    properties: {
        decay_to_expiry_cap: {
            type: 'number',
            format: 'double',
            description: `Explicit alias of \`theta_total\`, added per the Item 6 ticket's
literal JSON field-name request (\`min(|theta_day|*dte, extrinsic)\`,
now computed exactly via reprice rather than a post-hoc \`min()\`).`
        },
        div_yield: {
            type: 'number',
            format: 'double'
        },
        forward_price: {
            type: 'number',
            format: 'double'
        },
        theta_daily: {
            type: 'number',
            format: 'double',
            description: `Reprice-based decay over 1 calendar day, bounded by extrinsic value
by construction (Item 6 / P1). See \`strategy::leg::reprice_decay\`.`
        },
        theta_instantaneous_daily: {
            type: 'number',
            format: 'double',
            description: `Raw linear-derivative daily theta (\`abs(net_theta) / 365 * 100\`),
the pre-Item-6 convention — kept for consumers who explicitly want
the instantaneous rate rather than a bounded horizon projection.
UNBOUNDED: unlike \`theta_daily\`, this can exceed remaining extrinsic
value for short-dated positions; do not use it for a "safe to
collect" projection.`
        },
        theta_total: {
            type: 'number',
            format: 'double',
            description: `Reprice-based decay over the full DTE, i.e. the position's total
extrinsic value — identical to \`decay_to_expiry_cap\` below, kept
under its original name for display-layer compatibility.`
        },
        theta_weekly: {
            type: 'number',
            format: 'double',
            description: `Reprice-based decay over \`strategy::leg::WEEKLY_DECAY_HORIZON_DAYS\`
(7 calendar days), bounded by extrinsic value by construction.`
        },
        total_carry: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $CarryQuality = {
    type: 'object',
    description: 'Result of Bergomi carry quality computation.',
    required: ['carry_sharpe', 'pnl_variance', 'quality'],
    properties: {
        carry_sharpe: {
            type: 'number',
            format: 'double'
        },
        pnl_variance: {
            type: 'number',
            format: 'double'
        },
        quality: {
            '$ref': '#/components/schemas/CarryQualityLabel'
        }
    }
} as const;

export const $CarryQualityLabel = {
    type: 'string',
    description: 'Quality label for carry trade conviction.',
    enum: ['High', 'Medium', 'Low']
} as const;

export const $ChatCompletionChoice = {
    type: 'object',
    required: ['index', 'message'],
    properties: {
        finish_reason: {
            type: ['string', 'null']
        },
        index: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        },
        logprobs: {},
        message: {
            '$ref': '#/components/schemas/ChatCompletionMessage'
        }
    }
} as const;

export const $ChatCompletionChunk = {
    type: 'object',
    description: 'Represents a streamed chunk of a chat completion response returned',
    required: ['id', 'choices', 'created', 'model', 'object'],
    properties: {
        choices: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ChatCompletionChunkChoicesItem'
            },
            description: 'A list of chat completion choices. Can contain more than one elements if `n` is greater than 1. Can also be empty for the'
        },
        created: {
            type: 'integer',
            format: 'int64',
            description: 'The Unix timestamp (in seconds) of when the chat completion was created. Each chunk has the same timestamp.'
        },
        error: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ChatCompletionModerationError'
                }
            ]
        },
        id: {
            type: 'string',
            description: 'A unique identifier for the chat completion. Each chunk has the same ID.'
        },
        model: {
            type: 'string',
            description: 'The model to generate the completion.'
        },
        moderation: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ChatCompletionModeration'
                }
            ]
        },
        object: {
            '$ref': '#/components/schemas/ChatCompletionChunkObject',
            description: 'The object type, which is always `chat.completion.chunk`.'
        },
        service_tier: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ServiceTier'
                }
            ]
        },
        system_fingerprint: {
            type: ['string', 'null'],
            description: 'This fingerprint represents the backend configuration that the model runs with.'
        },
        usage: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/CompletionUsage',
                    description: 'An optional field that will only be present when you set'
                }
            ]
        }
    }
} as const;

export const $ChatCompletionChunkChoicesItem = {
    type: 'object',
    required: ['delta', 'index'],
    properties: {
        delta: {
            '$ref': '#/components/schemas/ChatCompletionStreamResponseDelta'
        },
        finish_reason: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ChatCompletionChunkChoicesItemFinishReason',
                    description: 'The reason the model stopped generating tokens. This will be `stop` if the model hit a natural stop point or a provided stop sequence,'
                }
            ]
        },
        index: {
            type: 'integer',
            format: 'int64',
            description: 'The index of the choice in the list of choices.'
        },
        logprobs: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ChatCompletionChunkChoicesItemLogprobs',
                    description: 'Log probability information for the choice.'
                }
            ]
        }
    }
} as const;

export const $ChatCompletionChunkChoicesItemFinishReason = {
    type: 'string',
    description: 'The reason the model stopped generating tokens. This will be `stop` if the model hit a natural stop point or a provided stop sequence,',
    enum: ['stop', 'length', 'tool_calls', 'content_filter', 'function_call']
} as const;

export const $ChatCompletionChunkChoicesItemLogprobs = {
    type: 'object',
    description: 'Log probability information for the choice.',
    required: ['content', 'refusal'],
    properties: {
        content: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ChatCompletionTokenLogprob'
            },
            description: 'A list of message content tokens with log probability information.'
        },
        refusal: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ChatCompletionTokenLogprob'
            },
            description: 'A list of message refusal tokens with log probability information.'
        }
    }
} as const;

export const $ChatCompletionChunkObject = {
    type: 'string',
    description: 'The object type, which is always `chat.completion.chunk`.',
    enum: ['chat.completion.chunk']
} as const;

export const $ChatCompletionMessage = {
    type: 'object',
    required: ['content'],
    properties: {
        content: {
            type: 'string'
        },
        refusal: {
            type: ['string', 'null']
        },
        role: {
            type: ['string', 'null']
        },
        tool_calls: {
            type: ['array', 'null'],
            items: {
                '$ref': '#/components/schemas/ToolCall'
            }
        }
    }
} as const;

export const $ChatCompletionMessageToolCallChunk = {
    type: 'object',
    required: ['index'],
    properties: {
        function: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ChatCompletionMessageToolCallChunkFunction'
                }
            ]
        },
        id: {
            type: ['string', 'null'],
            description: 'The ID of the tool call.'
        },
        index: {
            type: 'integer',
            format: 'int64'
        },
        type: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ChatCompletionMessageToolCallChunkType',
                    description: 'The type of the tool. Currently, only `function` is supported.'
                }
            ]
        }
    }
} as const;

export const $ChatCompletionMessageToolCallChunkFunction = {
    type: 'object',
    properties: {
        arguments: {
            type: ['string', 'null'],
            description: 'The arguments to call the function with, as generated by the model in JSON format. Note that the model does not always generate valid JSON, and may hallucinate parameters not defined by your functi...'
        },
        name: {
            type: ['string', 'null'],
            description: 'The name of the function to call.'
        }
    }
} as const;

export const $ChatCompletionMessageToolCallChunkType = {
    type: 'string',
    description: 'The type of the tool. Currently, only `function` is supported.',
    enum: ['function']
} as const;

export const $ChatCompletionModeration = {
    type: 'object',
    description: 'Moderation results or errors for the request input and generated output.',
    required: ['input', 'output'],
    properties: {
        input: {
            '$ref': '#/components/schemas/ChatCompletionModerationInput',
            description: 'Moderation for the request input.'
        },
        output: {
            '$ref': '#/components/schemas/ChatCompletionModerationOutput',
            description: 'Moderation for the generated output.'
        }
    }
} as const;

export const $ChatCompletionModerationError = {
    type: 'object',
    description: 'An error produced while attempting moderation.',
    required: ['type', 'code', 'message'],
    properties: {
        code: {
            type: 'string',
            description: 'The error code.'
        },
        message: {
            type: 'string',
            description: 'The error message.'
        },
        type: {
            '$ref': '#/components/schemas/ChatCompletionModerationErrorType',
            description: 'The object type, which is always `error`.'
        }
    }
} as const;

export const $ChatCompletionModerationErrorType = {
    type: 'string',
    description: 'The object type, which is always `error`.',
    enum: ['error']
} as const;

export const $ChatCompletionModerationInput = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ChatCompletionModerationResults'
        },
        {
            '$ref': '#/components/schemas/ChatCompletionModerationError'
        }
    ],
    description: 'Moderation for the request input.'
} as const;

export const $ChatCompletionModerationOutput = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ChatCompletionModerationResults'
        },
        {
            '$ref': '#/components/schemas/ChatCompletionModerationError'
        }
    ],
    description: 'Moderation for the generated output.'
} as const;

export const $ChatCompletionModerationResults = {
    type: 'object',
    description: 'Successful moderation results for the request input or generated output.',
    required: ['type', 'model', 'results'],
    properties: {
        model: {
            type: 'string',
            description: 'The moderation model used to generate the results.'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ModerationResultBody'
            },
            description: 'A list of moderation results.'
        },
        type: {
            '$ref': '#/components/schemas/ChatCompletionModerationResultsType',
            description: 'The object type, which is always `moderation_results`.'
        }
    }
} as const;

export const $ChatCompletionModerationResultsType = {
    type: 'string',
    description: 'The object type, which is always `moderation_results`.',
    enum: ['moderation_results']
} as const;

export const $ChatCompletionResponse = {
    type: 'object',
    required: ['id', 'object', 'created', 'model', 'choices', 'usage'],
    properties: {
        choices: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ChatCompletionChoice'
            }
        },
        created: {
            type: 'integer',
            format: 'int64',
            minimum: 0
        },
        error: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ChatCompletionModerationError'
                }
            ]
        },
        id: {
            type: 'string'
        },
        model: {
            type: 'string'
        },
        object: {
            type: 'string'
        },
        service_tier: {
            type: ['string', 'null']
        },
        usage: {
            '$ref': '#/components/schemas/ChatCompletionUsage'
        }
    }
} as const;

export const $ChatCompletionStreamResponseDelta = {
    type: 'object',
    description: 'A chat completion delta generated by streamed model responses.',
    properties: {
        content: {
            type: ['string', 'null']
        },
        function_call: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ChatCompletionStreamResponseDeltaFunctionCall',
                    description: 'Deprecated and replaced by `tool_calls`. The name and arguments of a function that should be called, as generated by the model.'
                }
            ]
        },
        refusal: {
            type: ['string', 'null']
        },
        role: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ChatCompletionStreamResponseDeltaRole',
                    description: 'The role of the author of this message.'
                }
            ]
        },
        tool_calls: {
            type: ['array', 'null'],
            items: {
                '$ref': '#/components/schemas/ChatCompletionMessageToolCallChunk'
            }
        }
    }
} as const;

export const $ChatCompletionStreamResponseDeltaFunctionCall = {
    type: 'object',
    description: 'Deprecated and replaced by `tool_calls`. The name and arguments of a function that should be called, as generated by the model.',
    properties: {
        arguments: {
            type: ['string', 'null'],
            description: 'The arguments to call the function with, as generated by the model in JSON format. Note that the model does not always generate valid JSON, and may hallucinate parameters not defined by your functi...'
        },
        name: {
            type: ['string', 'null'],
            description: 'The name of the function to call.'
        }
    }
} as const;

export const $ChatCompletionStreamResponseDeltaRole = {
    type: 'string',
    description: 'The role of the author of this message.',
    enum: ['developer', 'system', 'user', 'assistant', 'tool']
} as const;

export const $ChatCompletionTokenLogprob = {
    type: 'object',
    required: ['token', 'logprob', 'top_logprobs'],
    properties: {
        bytes: {
            type: ['array', 'null'],
            items: {
                type: 'integer',
                format: 'int64'
            }
        },
        logprob: {
            type: 'number',
            format: 'double',
            description: 'The log probability of this token, if it is within the top 20 most likely tokens. Otherwise, the value `-9999.0` is used to signify that the token is very unlikely.'
        },
        token: {
            type: 'string',
            description: 'The token.'
        },
        top_logprobs: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ChatCompletionTokenLogprobTopLogprobsItem'
            },
            description: 'List of the most likely tokens and their log probability, at this token position. The number of entries may be fewer than the requested `top_logprobs`.'
        }
    }
} as const;

export const $ChatCompletionTokenLogprobTopLogprobsItem = {
    type: 'object',
    required: ['token', 'logprob'],
    properties: {
        bytes: {
            type: ['array', 'null'],
            items: {
                type: 'integer',
                format: 'int64'
            }
        },
        logprob: {
            type: 'number',
            format: 'double',
            description: 'The log probability of this token, if it is within the top 20 most likely tokens. Otherwise, the value `-9999.0` is used to signify that the token is very unlikely.'
        },
        token: {
            type: 'string',
            description: 'The token.'
        }
    }
} as const;

export const $ChatCompletionUsage = {
    type: 'object',
    required: ['prompt_tokens', 'completion_tokens', 'total_tokens'],
    properties: {
        completion_tokens: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        },
        prompt_tokens: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        },
        total_tokens: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        }
    }
} as const;

export const $ChatMessage = {
    type: 'object',
    required: ['role', 'content'],
    properties: {
        content: {
            type: 'string'
        },
        created: {
            type: ['integer', 'null'],
            format: 'int32',
            minimum: 0
        },
        id: {
            type: ['string', 'null']
        },
        model: {
            type: ['string', 'null']
        },
        role: {
            type: 'string'
        },
        service_tier: {
            type: ['string', 'null']
        },
        tool_call_id: {
            type: ['string', 'null']
        },
        tool_calls: {
            type: ['array', 'null'],
            items: {
                '$ref': '#/components/schemas/ToolCall'
            }
        }
    }
} as const;

export const $Claims = {
    type: 'object',
    description: 'Our claims struct, it needs to derive `Serialize` and/or `Deserialize`',
    required: ['user_id', 'iss', 'exp', 'iat', 'roles'],
    properties: {
        exp: {
            type: 'integer',
            format: 'int64',
            minimum: 0
        },
        iat: {
            type: 'integer',
            format: 'int64',
            minimum: 0
        },
        is_institutional: {
            type: ['boolean', 'null']
        },
        iss: {
            type: 'string'
        },
        memberships: {
            type: ['array', 'null'],
            items: {
                '$ref': '#/components/schemas/Membership'
            }
        },
        roles: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        userType: {
            type: ['integer', 'null'],
            format: 'int32'
        },
        user_id: {
            type: 'string'
        },
        wpID: {
            type: ['integer', 'null'],
            format: 'int64'
        }
    }
} as const;

export const $ComboSet = {
    type: 'object',
    required: ['combo', 'shard', 'symbols', 'price_sym'],
    properties: {
        combo: {
            type: 'string'
        },
        price_sym: {
            '$ref': '#/components/schemas/Sym'
        },
        shard: {
            type: 'integer',
            format: 'int32'
        },
        symbols: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Sym'
            }
        }
    }
} as const;

export const $CompletionUsage = {
    type: 'object',
    description: 'Usage statistics for the completion request.',
    required: ['completion_tokens', 'prompt_tokens', 'total_tokens'],
    properties: {
        completion_tokens: {
            type: 'integer',
            format: 'int64',
            description: 'Number of tokens in the generated completion.'
        },
        completion_tokens_details: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/CompletionUsageCompletionTokensDetails',
                    description: 'Breakdown of tokens used in a completion.'
                }
            ]
        },
        prompt_tokens: {
            type: 'integer',
            format: 'int64',
            description: 'Number of tokens in the prompt.'
        },
        prompt_tokens_details: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/CompletionUsagePromptTokensDetails',
                    description: 'Breakdown of tokens used in the prompt.'
                }
            ]
        },
        total_tokens: {
            type: 'integer',
            format: 'int64',
            description: 'Total number of tokens used in the request (prompt + completion).'
        }
    }
} as const;

export const $CompletionUsageCompletionTokensDetails = {
    type: 'object',
    description: 'Breakdown of tokens used in a completion.',
    properties: {
        accepted_prediction_tokens: {
            type: ['integer', 'null'],
            format: 'int64',
            description: 'When using Predicted Outputs, the number of tokens in the'
        },
        audio_tokens: {
            type: ['integer', 'null'],
            format: 'int64',
            description: 'Audio input tokens generated by the model.'
        },
        reasoning_tokens: {
            type: ['integer', 'null'],
            format: 'int64',
            description: 'Tokens generated by the model for reasoning.'
        },
        rejected_prediction_tokens: {
            type: ['integer', 'null'],
            format: 'int64',
            description: 'When using Predicted Outputs, the number of tokens in the'
        }
    }
} as const;

export const $CompletionUsagePromptTokensDetails = {
    type: 'object',
    description: 'Breakdown of tokens used in the prompt.',
    properties: {
        audio_tokens: {
            type: ['integer', 'null'],
            format: 'int64',
            description: 'Audio input tokens present in the prompt.'
        },
        cache_write_tokens: {
            type: ['integer', 'null'],
            format: 'int64',
            description: 'The unadjusted number of prompt tokens written to cache.'
        },
        cached_tokens: {
            type: ['integer', 'null'],
            format: 'int64',
            description: 'Cached tokens present in the prompt.'
        }
    }
} as const;

export const $ContextSpec = {
    type: 'object',
    properties: {
        across_earnings: {
            type: ['boolean', 'null']
        },
        across_ex_date: {
            type: ['boolean', 'null']
        },
        open_legs: {
            type: ['array', 'null'],
            items: {
                '$ref': '#/components/schemas/OpenLeg'
            }
        },
        owns_shares: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/OwnsShares'
                }
            ]
        }
    }
} as const;

export const $ContractHighlight = {
    type: 'object',
    required: ['underlying', 'premium', 'expiry', 'strike', 'is_put'],
    properties: {
        expiry: {
            type: 'string',
            format: 'date-time'
        },
        is_put: {
            type: 'boolean'
        },
        premium: {
            type: 'number',
            format: 'double'
        },
        strike: {
            type: 'number',
            format: 'double'
        },
        underlying: {
            type: 'string'
        }
    }
} as const;

export const $ContractRow = {
    type: 'object',
    required: ['underlying', 'is_put', 'strike', 'expiry', 'total_volume', 'total_premium', 'delta_notional', 'gamma_notional', 'vega_notional'],
    properties: {
        delta_notional: {
            type: 'number',
            format: 'double'
        },
        expiry: {
            type: 'string',
            format: 'date-time'
        },
        gamma_notional: {
            type: 'number',
            format: 'double'
        },
        is_put: {
            type: 'boolean'
        },
        prev_oi: {
            type: ['integer', 'null'],
            format: 'int64'
        },
        strike: {
            type: 'number',
            format: 'float'
        },
        total_premium: {
            type: 'number',
            format: 'double'
        },
        total_volume: {
            type: 'number',
            format: 'double'
        },
        underlying: {
            type: 'string'
        },
        vega_notional: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $CorrRegimeBucket = {
    type: 'string',
    description: 'Cross-sectional correlation regime bucket from the index/single IV proxy.',
    enum: ['LowCorr', 'MidCorr', 'HighCorr', 'Unknown']
} as const;

export const $CorrelationMetrics = {
    type: 'object',
    description: 'Pre-computed correlation metrics.',
    required: ['corr_spy_20d', 'corr_spy_60d', 'corr_sector_20d', 'corr_sector_60d', 'sector_dispersion_20d', 'implied_correlation', 'relative_to_sector', 'relative_to_spy', 'sector_relative_to_spy', 'symbol_return', 'sector_return', 'spy_return', 'sector_etf', 'symbol_rv_rank', 'sector_rv_rank', 'index_rv_rank', 'symbol_vrp_ratio', 'symbol_vrp_level', 'sector_vrp_ratio', 'sector_vrp_level', 'index_vrp_ratio', 'index_vrp_level', 'symbol_iv_change_5d', 'sector_iv_change_5d', 'index_iv_change_5d', 'implied_corr_premium', 'systematic_variance_share', 'idio_iv_residual', 'peer_iv_dispersion', 'data_points'],
    properties: {
        corr_sector_20d: {
            type: 'number',
            format: 'double'
        },
        corr_sector_60d: {
            type: 'number',
            format: 'double'
        },
        corr_spy_20d: {
            type: 'number',
            format: 'double',
            description: 'Rolling correlations'
        },
        corr_spy_60d: {
            type: 'number',
            format: 'double'
        },
        data_points: {
            type: 'integer',
            description: 'Number of trading days of input data used for metrics',
            minimum: 0
        },
        idio_iv_residual: {
            type: 'number',
            format: 'double',
            description: 'Idiosyncratic IV residual from regressing symbol IV on sector + index IV'
        },
        implied_corr_premium: {
            type: 'number',
            format: 'double',
            description: 'Implied correlation premium (implied_correlation - realized_corr_20d)'
        },
        implied_correlation: {
            type: 'number',
            format: 'double'
        },
        index_iv_change_5d: {
            type: 'number',
            format: 'double',
            description: 'Index/SPY 5-day IV change'
        },
        index_rv_rank: {
            type: 'number',
            format: 'double',
            description: 'Index/SPY realized-vol rank percentile (0-100). Same RV proxy caveat as above.'
        },
        index_vrp_level: {
            type: 'number',
            format: 'double',
            description: 'Index/SPY VRP level'
        },
        index_vrp_ratio: {
            type: 'number',
            format: 'double',
            description: 'Index/SPY VRP ratio'
        },
        peer_iv_dispersion: {
            type: 'number',
            format: 'double',
            description: 'Peer IV dispersion (cross-sectional std dev of peer returns in sector)'
        },
        relative_to_sector: {
            type: 'number',
            format: 'double',
            description: 'Relative moves (daily returns)'
        },
        relative_to_spy: {
            type: 'number',
            format: 'double'
        },
        sector_dispersion_20d: {
            type: 'number',
            format: 'double',
            description: 'Dispersion metrics'
        },
        sector_etf: {
            type: 'string',
            description: 'Sector info'
        },
        sector_iv_change_5d: {
            type: 'number',
            format: 'double',
            description: 'Sector ETF 5-day IV change'
        },
        sector_relative_to_spy: {
            type: 'number',
            format: 'double'
        },
        sector_return: {
            type: 'number',
            format: 'double'
        },
        sector_rv_rank: {
            type: 'number',
            format: 'double',
            description: 'Sector ETF realized-vol rank percentile (0-100). Same RV proxy caveat as above.'
        },
        sector_vrp_level: {
            type: 'number',
            format: 'double',
            description: 'Sector ETF VRP level'
        },
        sector_vrp_ratio: {
            type: 'number',
            format: 'double',
            description: 'Sector ETF VRP ratio'
        },
        spy_return: {
            type: 'number',
            format: 'double'
        },
        symbol_iv_change_5d: {
            type: 'number',
            format: 'double',
            description: 'Symbol 5-day IV change (current proxy IV - 5d ago proxy IV)'
        },
        symbol_return: {
            type: 'number',
            format: 'double',
            description: 'Raw returns (for diagnostics)'
        },
        symbol_rv_rank: {
            type: 'number',
            format: 'double',
            description: `Symbol realized-vol rank percentile (0-100). RV-based proxy for IV rank —
NOT a true implied-vol percentile. See \`compute_rv_rank_proxy\` in correlation.rs.`
        },
        symbol_vrp_level: {
            type: 'number',
            format: 'double',
            description: 'Symbol VRP level (IV proxy - RV proxy)'
        },
        symbol_vrp_ratio: {
            type: 'number',
            format: 'double',
            description: 'Symbol VRP ratio (IV proxy / RV proxy)'
        },
        systematic_variance_share: {
            type: 'number',
            format: 'double',
            description: 'Systematic variance share (beta^2 * Var(index) / Var(symbol))'
        }
    }
} as const;

export const $CorrelationOutput = {
    type: 'object',
    description: 'Correlation regime detection output.',
    required: ['regime', 'confidence', 'prob_idiosyncratic', 'prob_sector_stress', 'prob_systemic', 'metrics', 'vol_multiplier', 'mr_speed_multiplier', 'detection_reason'],
    properties: {
        confidence: {
            type: 'number',
            format: 'double'
        },
        detection_reason: {
            type: 'string',
            description: 'Diagnostics'
        },
        metrics: {
            '$ref': '#/components/schemas/CorrelationMetrics',
            description: 'Metrics used for detection'
        },
        mr_speed_multiplier: {
            type: 'number',
            format: 'double'
        },
        prob_idiosyncratic: {
            type: 'number',
            format: 'double',
            description: 'Regime classification scores (0.0-1.0)'
        },
        prob_sector_stress: {
            type: 'number',
            format: 'double'
        },
        prob_systemic: {
            type: 'number',
            format: 'double'
        },
        regime: {
            '$ref': '#/components/schemas/CorrelationRegime'
        },
        vol_multiplier: {
            type: 'number',
            format: 'double',
            description: 'Suggested vol adjustments'
        }
    }
} as const;

export const $CorrelationRegime = {
    type: 'string',
    description: 'Correlation regime classification.',
    enum: ['Idiosyncratic', 'SectorStress', 'Systemic', 'Unknown']
} as const;

export const $CorrelationRegimeResponse = {
    type: 'object',
    required: ['symbol', 'date', 'regime_type', 'confidence', 'prob_idiosyncratic', 'prob_sector_stress', 'prob_systemic', 'vol_multiplier', 'mr_speed_multiplier', 'sector_etf', 'corr_spy_20d', 'corr_spy_60d', 'corr_sector_20d', 'corr_sector_60d', 'sector_dispersion_20d', 'implied_correlation', 'relative_to_sector', 'relative_to_spy', 'sector_relative_to_spy', 'symbol_return', 'sector_return', 'spy_return', 'symbol_iv_rank', 'sector_iv_rank', 'index_iv_rank', 'symbol_vrp_ratio', 'symbol_vrp_level', 'sector_vrp_ratio', 'sector_vrp_level', 'index_vrp_ratio', 'index_vrp_level', 'symbol_iv_change_5d', 'sector_iv_change_5d', 'index_iv_change_5d', 'implied_corr_premium', 'systematic_variance_share', 'idio_iv_residual', 'peer_iv_dispersion'],
    properties: {
        confidence: {
            type: 'number',
            format: 'double'
        },
        corr_sector_20d: {
            type: 'number',
            format: 'double'
        },
        corr_sector_60d: {
            type: 'number',
            format: 'double'
        },
        corr_spy_20d: {
            type: 'number',
            format: 'double'
        },
        corr_spy_60d: {
            type: 'number',
            format: 'double'
        },
        date: {
            type: 'string'
        },
        idio_iv_residual: {
            type: 'number',
            format: 'double'
        },
        implied_corr_premium: {
            type: 'number',
            format: 'double'
        },
        implied_correlation: {
            type: 'number',
            format: 'double'
        },
        index_iv_change_5d: {
            type: 'number',
            format: 'double'
        },
        index_iv_rank: {
            type: 'number',
            format: 'double'
        },
        index_vrp_level: {
            type: 'number',
            format: 'double'
        },
        index_vrp_ratio: {
            type: 'number',
            format: 'double'
        },
        mr_speed_multiplier: {
            type: 'number',
            format: 'double'
        },
        peer_iv_dispersion: {
            type: 'number',
            format: 'double'
        },
        prob_idiosyncratic: {
            type: 'number',
            format: 'double'
        },
        prob_sector_stress: {
            type: 'number',
            format: 'double'
        },
        prob_systemic: {
            type: 'number',
            format: 'double'
        },
        regime_type: {
            type: 'string'
        },
        relative_to_sector: {
            type: 'number',
            format: 'double'
        },
        relative_to_spy: {
            type: 'number',
            format: 'double'
        },
        sector_dispersion_20d: {
            type: 'number',
            format: 'double'
        },
        sector_etf: {
            type: 'string'
        },
        sector_iv_change_5d: {
            type: 'number',
            format: 'double'
        },
        sector_iv_rank: {
            type: 'number',
            format: 'double'
        },
        sector_relative_to_spy: {
            type: 'number',
            format: 'double'
        },
        sector_return: {
            type: 'number',
            format: 'double'
        },
        sector_vrp_level: {
            type: 'number',
            format: 'double'
        },
        sector_vrp_ratio: {
            type: 'number',
            format: 'double'
        },
        spy_return: {
            type: 'number',
            format: 'double'
        },
        symbol: {
            type: 'string'
        },
        symbol_iv_change_5d: {
            type: 'number',
            format: 'double'
        },
        symbol_iv_rank: {
            type: 'number',
            format: 'double'
        },
        symbol_return: {
            type: 'number',
            format: 'double'
        },
        symbol_vrp_level: {
            type: 'number',
            format: 'double'
        },
        symbol_vrp_ratio: {
            type: 'number',
            format: 'double'
        },
        systematic_variance_share: {
            type: 'number',
            format: 'double'
        },
        vol_multiplier: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $CostBasis = {
    type: 'string',
    enum: ['quotes', 'model']
} as const;

export const $CostSign = {
    type: 'string',
    enum: ['credit', 'debit', 'even']
} as const;

export const $CostSpec = {
    type: 'object',
    properties: {
        max_debit: {
            type: ['number', 'null'],
            format: 'double'
        },
        min_credit: {
            type: ['number', 'null'],
            format: 'double'
        },
        sign: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/CostSign'
                }
            ]
        }
    }
} as const;

export const $CrossRiskTenorAdjustment = {
    type: 'object',
    description: 'Per-tenor cross-risk adjustment showing what bumps were applied.',
    required: ['tenor_days', 'original_atm_iv', 'variance_bump', 'adjusted_atm_iv', 'contributing_peers'],
    properties: {
        adjusted_atm_iv: {
            type: 'number',
            format: 'double',
            description: 'ATM IV after cross-risk adjustment.'
        },
        contributing_peers: {
            type: 'array',
            items: {
                type: 'string'
            },
            description: "Which peer events contributed to this tenor's adjustment."
        },
        original_atm_iv: {
            type: 'number',
            format: 'double',
            description: 'ATM IV before cross-risk adjustment.'
        },
        tenor_days: {
            type: 'number',
            format: 'double',
            description: 'Tenor in calendar days (e.g. 30, 60, 91).'
        },
        variance_bump: {
            type: 'number',
            format: 'double',
            description: 'Variance adjustment applied (negative = vol crush).'
        }
    }
} as const;

export const $CurvatureBacktestRow = {
    type: 'object',
    description: 'Curvature across three tenors: IV(mid) - 0.5*(IV(short) + IV(long)).',
    required: ['as_of_date', 'future_date', 'hold_days', 'short_tenor', 'mid_tenor', 'long_tenor', 'current_curvature', 'projected_curvature', 'realized_curvature', 'error', 'unchanged_error', 'beats_unchanged'],
    properties: {
        as_of_date: {
            type: 'string'
        },
        beats_unchanged: {
            type: 'boolean',
            description: 'Whether projected was closer to realized than unchanged.'
        },
        current_curvature: {
            type: 'number',
            format: 'double',
            description: 'Curvature = IV(mid) - 0.5*(IV(short) + IV(long)) at as-of date.'
        },
        error: {
            type: 'number',
            format: 'double',
            description: 'projected - realized'
        },
        future_date: {
            type: 'string'
        },
        hold_days: {
            type: 'integer',
            format: 'int32'
        },
        long_tenor: {
            type: 'integer',
            format: 'int32'
        },
        mid_tenor: {
            type: 'integer',
            format: 'int32'
        },
        projected_curvature: {
            type: 'number',
            format: 'double',
            description: 'Curvature in projected surface.'
        },
        realized_curvature: {
            type: 'number',
            format: 'double',
            description: 'Curvature observed on future date.'
        },
        short_tenor: {
            type: 'integer',
            format: 'int32'
        },
        unchanged_error: {
            type: 'number',
            format: 'double',
            description: 'current - realized (unchanged baseline)'
        }
    }
} as const;

export const $CurvatureTripleSummary = {
    type: 'object',
    description: 'Aggregate statistics for one curvature triple.',
    required: ['short_tenor', 'mid_tenor', 'long_tenor', 'rows', 'projected_mae', 'unchanged_mae', 'model_beat_count', 'total_rows'],
    properties: {
        long_tenor: {
            type: 'integer',
            format: 'int32'
        },
        mid_tenor: {
            type: 'integer',
            format: 'int32'
        },
        model_beat_count: {
            type: 'integer',
            minimum: 0
        },
        projected_mae: {
            type: 'number',
            format: 'double'
        },
        rows: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CurvatureBacktestRow'
            }
        },
        short_tenor: {
            type: 'integer',
            format: 'int32'
        },
        total_rows: {
            type: 'integer',
            minimum: 0
        },
        unchanged_mae: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $DecSeasonal = {
    type: 'string',
    description: `Whether \`trade_date\` falls within calendar-month December (the
"December Effect" seasonal window per Choy/Wei/Zhang, SSRN 5121679).
Informational only today — does not gate any strategy generation.`,
    enum: ['December', 'NotDecember']
} as const;

export const $DeltaSignalFilters = {
    type: 'object',
    required: ['option_accumulation_type', 'option_origin', 'is_filtered'],
    properties: {
        is_filtered: {
            type: 'boolean'
        },
        option_accumulation_type: {
            '$ref': '#/components/schemas/OptionAccumulationType'
        },
        option_origin: {
            '$ref': '#/components/schemas/OptionOrigin'
        }
    }
} as const;

export const $DeltaSignalRsp = {
    allOf: [
        {
            '$ref': '#/components/schemas/CandlesRsp'
        },
        {
            '$ref': '#/components/schemas/DeltaSignalFilters'
        }
    ]
} as const;

export const $DeltaStrikes = {
    type: 'object',
    properties: {
        body: {
            type: ['number', 'null'],
            format: 'double'
        },
        short: {
            type: ['number', 'null'],
            format: 'double'
        },
        wings: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $DeltaTarget = {
    oneOf: [
        {
            type: 'string'
        },
        {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            },
            maxItems: 2,
            minItems: 2
        }
    ]
} as const;

export const $DerivedMetrics = {
    type: 'object',
    properties: {
        atm_richness_30d_vol_pts: {
            type: ['number', 'null'],
            format: 'double'
        },
        atm_richness_7d_vol_pts: {
            type: ['number', 'null'],
            format: 'double'
        },
        atm_richness_90d_vol_pts: {
            type: ['number', 'null'],
            format: 'double'
        },
        avg_surface_richness_vol_pts: {
            type: ['number', 'null'],
            format: 'double'
        },
        bennett_skew_regime: {
            type: ['string', 'null']
        },
        event_iv_drop_pct: {
            type: ['number', 'null'],
            format: 'double'
        },
        event_iv_premium_pct_pts: {
            type: ['number', 'null'],
            format: 'double'
        },
        fwd_vol_30d_90d: {
            type: ['number', 'null'],
            format: 'double'
        },
        fwd_vol_7d_30d: {
            type: ['number', 'null'],
            format: 'double'
        },
        fwd_vol_cheap_flag: {
            type: ['boolean', 'null']
        },
        fwd_vol_ratio_long: {
            type: ['number', 'null'],
            format: 'double'
        },
        fwd_vol_ratio_short: {
            type: ['number', 'null'],
            format: 'double'
        },
        implied_jump_pct: {
            type: ['number', 'null'],
            format: 'double'
        },
        iv_mean_dev_sigma: {
            type: ['number', 'null'],
            format: 'double'
        },
        mean_reversion_zone: {
            type: ['string', 'null']
        },
        overall_surface_signal: {
            type: ['string', 'null']
        },
        post_event_iv: {
            type: ['number', 'null'],
            format: 'double'
        },
        surface_rmse_vol_pts: {
            type: ['number', 'null'],
            format: 'double'
        },
        surface_signal_30d: {
            type: ['string', 'null']
        },
        surface_signal_7d: {
            type: ['string', 'null']
        },
        surface_signal_90d: {
            type: ['string', 'null']
        },
        vol_cone_percentile: {
            type: ['number', 'null'],
            format: 'double'
        },
        vol_ratio_30d_90d: {
            type: ['number', 'null'],
            format: 'double'
        },
        vol_ratio_7d_30d: {
            type: ['number', 'null'],
            format: 'double'
        },
        wing_richness_signal: {
            type: ['string', 'null']
        },
        wing_skew_richness_vol_pts: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $Direction = {
    type: 'string',
    description: 'Direction bias for scenario analysis and strategy filtering.',
    enum: ['bullish', 'bearish', 'neutral']
} as const;

export const $DirectionalBias = {
    type: 'string',
    description: 'Directional bias for scenario forecast.',
    enum: ['iv_likely_lower', 'iv_likely_higher', 'neutral']
} as const;

export const $DividendAlert = {
    type: 'object',
    required: ['ex_date', 'amount', 'confirmed', 'delta_drag'],
    properties: {
        amount: {
            type: 'number',
            format: 'double'
        },
        confirmed: {
            type: 'boolean'
        },
        delta_drag: {
            type: 'number',
            format: 'double'
        },
        ex_date: {
            type: 'string'
        }
    }
} as const;

export const $DollarValuePerContract = {
    type: 'object',
    required: ['strike', 'expiration', 'dte', 'is_call', 'market_price', 'projected_price', 'dollar_value', 'projected_iv', 'multiplier'],
    properties: {
        dollar_value: {
            type: 'number',
            format: 'double'
        },
        dte: {
            type: 'integer',
            format: 'int32'
        },
        expiration: {
            type: 'string'
        },
        is_call: {
            type: 'boolean'
        },
        market_price: {
            type: 'number',
            format: 'double'
        },
        multiplier: {
            type: 'number',
            format: 'double'
        },
        projected_iv: {
            type: 'number',
            format: 'double'
        },
        projected_price: {
            type: 'number',
            format: 'double'
        },
        strike: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $DollarValueSummary = {
    type: 'object',
    required: ['expiration', 'dte', 'contract_count', 'total_dollar_value', 'avg_dollar_value', 'max_dollar_value', 'max_strike', 'min_dollar_value', 'min_strike'],
    properties: {
        avg_dollar_value: {
            type: 'number',
            format: 'double'
        },
        contract_count: {
            type: 'integer',
            minimum: 0
        },
        dte: {
            type: 'integer',
            format: 'int32'
        },
        expiration: {
            type: 'string'
        },
        max_dollar_value: {
            type: 'number',
            format: 'double'
        },
        max_strike: {
            type: 'number',
            format: 'double'
        },
        min_dollar_value: {
            type: 'number',
            format: 'double'
        },
        min_strike: {
            type: 'number',
            format: 'double'
        },
        total_dollar_value: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $EnrichedRegime = {
    type: 'object',
    description: 'Enriched regime with overlay and adjusted MR speed.',
    required: ['derman', 'derman_confidence', 'overlay', 'adjusted_mr_speed'],
    properties: {
        adjusted_mr_speed: {
            type: 'number',
            format: 'double'
        },
        derman: {
            '$ref': '#/components/schemas/VolatilityRegime'
        },
        derman_confidence: {
            type: 'number',
            format: 'double'
        },
        iv_rank: {
            type: ['number', 'null'],
            format: 'double'
        },
        overlay: {
            '$ref': '#/components/schemas/OverlayRegime'
        }
    }
} as const;

export const $EntityDirection = {
    type: 'string',
    description: 'Entity direction classification (bullish, bearish, mixed).',
    enum: ['bullish', 'bearish', 'mixed']
} as const;

export const $EntityVolPoints = {
    type: 'object',
    description: 'SGOI entity vol points.',
    required: ['delta_not'],
    properties: {
        delta_not: {
            type: 'number',
            format: 'double'
        },
        gamma_pct: {
            type: ['number', 'null'],
            format: 'double'
        },
        high: {
            type: ['number', 'null'],
            format: 'double'
        },
        low: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $EquityLevels = {
    type: 'object',
    description: `One symbol's daily Equity Hub row.

This type exists to describe and bound the JSON payload rather than to parse it: the row is
forwarded from the model's stored payload as-is, so the values keep whatever JSON types the
upstream model wrote. What it *does* control is which fields are served - [\`kept_fields\`]
takes the allowlist straight from this schema, so a field that isn't documented here is not
returned, and the two cannot drift apart.

Every field is optional: the upstream query left-joins several sources, so any given symbol
may be missing values.`,
    properties: {
        atm_iv30: {
            type: ['number', 'null'],
            format: 'double',
            description: 'At-the-money 30DTE implied volatility.'
        },
        atm_iv30_pct_chg: {
            type: ['number', 'null'],
            format: 'double',
            description: `Day-over-day change in at-the-money 30DTE implied volatility, as a fraction of the prior
session's value.`
        },
        atmdc: {
            type: ['number', 'null'],
            format: 'double',
            description: 'At-the-money call delta notional.'
        },
        atmdp: {
            type: ['number', 'null'],
            format: 'double',
            description: 'At-the-money put delta notional.'
        },
        atmgc: {
            type: ['number', 'null'],
            format: 'double',
            description: 'At-the-money call gamma.'
        },
        atmgp: {
            type: ['number', 'null'],
            format: 'double',
            description: 'At-the-money put gamma.'
        },
        call_gnot_list_absg: {
            type: ['string', 'null'],
            description: 'Absolute call gamma notional.'
        },
        call_strikes_list_absg: {
            type: ['string', 'null'],
            description: 'Associative array of strikes for `call_gnot_list_absg`.'
        },
        callsum: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Call open interest.'
        },
        cg_list: {
            type: ['string', 'null'],
            description: 'Call gamma for each strike, index-aligned with `strike_list`.'
        },
        cskew: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Call skew.'
        },
        cskew_pct: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Call skew rank.'
        },
        cv: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Call volume.'
        },
        cws: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Call wall strike.'
        },
        d25: {
            type: ['number', 'null'],
            format: 'double',
            description: '30DTE IV at 25DC (25-delta call).'
        },
        d25ne: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Next expiration implied volatility at 25DC (25-delta call).'
        },
        d95: {
            type: ['number', 'null'],
            format: 'double',
            description: '30DTE IV at 5DP (5-delta put).'
        },
        d95ne: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Next expiration implied volatility at 5DP (5-delta put).'
        },
        earnings_utc: {
            type: ['string', 'null'],
            description: 'Next earnings, UTC.'
        },
        iv_pct: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Implied volatility percentile.'
        },
        iv_rank: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Implied volatility rank.'
        },
        keyd: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Key delta strike.'
        },
        keyg: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Key gamma strike.'
        },
        largeCoi: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Largest call open interest strike.'
        },
        largePoi: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Largest put open interest strike.'
        },
        max_exp_d_date: {
            type: ['string', 'null'],
            description: 'Expiration with the most total delta notional.'
        },
        max_exp_g_date: {
            type: ['string', 'null'],
            description: 'Expiration with the most total gamma.'
        },
        maxfs: {
            type: ['number', 'null'],
            format: 'double',
            description: "Hedge wall. For index symbols this carries the index model's Volatility Trigger instead."
        },
        name: {
            type: ['string', 'null'],
            description: 'Full name.'
        },
        next_exp_call_gamma: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Next expiration call gamma.'
        },
        next_exp_d: {
            type: ['number', 'null'],
            format: 'double',
            description: "Next expiration total delta, as a share of the symbol's total delta (0-1)."
        },
        next_exp_g: {
            type: ['number', 'null'],
            format: 'double',
            description: "Next expiration total gamma, as a share of the symbol's total gamma (0-1)."
        },
        next_exp_put_gamma: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Next expiration put gamma.'
        },
        options_implied_move: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Options implied move.'
        },
        pg_list: {
            type: ['string', 'null'],
            description: 'Put gamma for each strike, index-aligned with `strike_list`.'
        },
        prev_cws: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Previous call wall strike.'
        },
        prev_keyg: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Previous key gamma strike.'
        },
        prev_maxfs: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Previous hedge wall.'
        },
        prev_pws: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Previous put wall strike.'
        },
        pskew: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Put skew.'
        },
        pskew_pct: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Put skew rank.'
        },
        put_call_ratio: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Put/call open interest ratio (`putsum / callsum`).'
        },
        put_gnot_list_absg: {
            type: ['string', 'null'],
            description: 'Absolute put gamma notional.'
        },
        put_strikes_list_absg: {
            type: ['string', 'null'],
            description: 'Associative array of strikes for `put_gnot_list_absg`.'
        },
        putsum: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Put open interest.'
        },
        pv: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Put volume.'
        },
        pws: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Put wall strike.'
        },
        quote_date: {
            type: ['string', 'null'],
            description: 'Alias of `trade_date`.'
        },
        rv30: {
            type: ['number', 'null'],
            format: 'double',
            description: '30-day realized volatility.'
        },
        skew: {
            type: ['number', 'null'],
            format: 'double',
            description: `30-day IV skew, \`(d25 - d75) / d50\`. A high reading indicates call demand is high
relative to put demand.`
        },
        skew_rank: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Skew rank.'
        },
        strike_list: {
            type: ['string', 'null'],
            description: `Associative array of strikes relevant to \`cg_list\`, \`pg_list\`, etc. Serialized as an
array inside a JSON string.`
        },
        sym: {
            type: ['string', 'null'],
            description: 'Ticker symbol.'
        },
        total_volume: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Total underlying volume.'
        },
        trade_date: {
            type: ['string', 'null'],
            description: 'Trade date the model run was computed from.'
        },
        upx: {
            type: ['number', 'null'],
            format: 'double',
            description: "Last closing price. SpotGamma models from the prior session's close."
        },
        volume_ratio: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Put/call volume ratio (`pv / cv`).'
        }
    }
} as const;

export const $ErrorRsp = {
    type: 'object',
    required: ['status_code', 'msg'],
    properties: {
        msg: {
            type: 'string'
        },
        status_code: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        }
    }
} as const;

export const $EventAdjustedVrp = {
    type: 'object',
    description: "Result of stripping a name's own priced event variance from its VRP.",
    required: ['event_days_until', 'sigma_j_sq', 'priced_event_move_pct', 'tenor_days', 'raw_atm_iv', 'diffusive_atm_iv', 'realized_vol', 'raw_vrp_level', 'ex_event_vrp_level', 'raw_vrp_ratio', 'ex_event_vrp_ratio'],
    properties: {
        diffusive_atm_iv: {
            type: 'number',
            format: 'double',
            description: 'Diffusive ATM IV after stripping σ²_j/T.'
        },
        event_days_until: {
            type: 'integer',
            format: 'int32',
            description: "Days until the target's own earnings announcement (>= 0)."
        },
        ex_event_vrp_level: {
            type: 'number',
            format: 'double',
            description: 'Ex-event VRP level (diffusive_atm_iv - realized_vol).'
        },
        ex_event_vrp_ratio: {
            type: 'number',
            format: 'double',
            description: 'Ex-event VRP ratio (diffusive_atm_iv / realized_vol).'
        },
        priced_event_move_pct: {
            type: 'number',
            format: 'double',
            description: 'Single-day priced event move sqrt(σ²_j) as a percentage.'
        },
        raw_atm_iv: {
            type: 'number',
            format: 'double',
            description: 'Raw ATM IV at the tenor (includes the event premium).'
        },
        raw_vrp_level: {
            type: 'number',
            format: 'double',
            description: 'Raw VRP level (raw_atm_iv - realized_vol).'
        },
        raw_vrp_ratio: {
            type: 'number',
            format: 'double',
            description: 'Raw VRP ratio (raw_atm_iv / realized_vol).'
        },
        realized_vol: {
            type: 'number',
            format: 'double',
            description: 'Realized vol used as the VRP baseline.'
        },
        sigma_j_sq: {
            type: 'number',
            format: 'double',
            description: 'Risk-neutral event variance σ²_j (unitless squared jump size).'
        },
        tenor_days: {
            type: 'integer',
            format: 'int32',
            description: 'Tenor the headline decomposition is computed at (defaults to 30).'
        }
    }
} as const;

export const $EventSignal = {
    type: 'object',
    description: 'Event detection result.',
    required: ['detected', 'forward_vol_ratio', 'term_kink_magnitude', 'confidence', 'description', 'is_post_event', 'event_source'],
    properties: {
        confidence: {
            type: 'number',
            format: 'double'
        },
        days_to_event: {
            type: ['integer', 'null'],
            format: 'int32',
            description: `Single-day approximation used by downstream consumers (surface projection,
bucket classification) that key off one scalar. Kept as the bracket
midpoint for backward compatibility when \`event_window\` is set.`
        },
        description: {
            type: 'string'
        },
        detected: {
            type: 'boolean'
        },
        event_source: {
            type: 'string'
        },
        event_window: {
            type: ['array', 'null'],
            items: false,
            prefixItems: [
                {
                    type: 'integer',
                    format: 'int32'
                },
                {
                    type: 'integer',
                    format: 'int32'
                }
            ],
            description: `Honest output of the detector: the localized [from_dte, to_dte] window
on the tenor grid that contains the event. Populated for bracket-based
detection (event_source == "fwd_var_bracket"). None otherwise.`
        },
        forward_vol_ratio: {
            type: 'number',
            format: 'double'
        },
        is_post_event: {
            type: 'boolean'
        },
        term_kink_magnitude: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $EventWindowZone = {
    type: 'string',
    description: 'Position in the event window relative to the strategy hold.',
    enum: ['NoEvent', 'InsideHold', 'RampAhead']
} as const;

export const $ExclusionRecord = {
    type: 'object',
    description: `SE-05: a single candidate excluded by event/correlation conditioning, with
the reason it was removed. Event conditioning may exclude or tie-break --
it must never rewrite \`final_score\`/\`expected_return\` (see
\`crate::moviefone::analysis::analysis_helpers::apply_stance_conditioning\`).`,
    required: ['name', 'reason'],
    properties: {
        name: {
            '$ref': '#/components/schemas/StrategyName'
        },
        reason: {
            type: 'string'
        }
    }
} as const;

export const $ExerciseStyle = {
    type: 'string',
    description: `Whether a symbol's US-listed equity/index options allow early exercise.

This flag is currently consumed only by the intrinsic floor (always
applied regardless of style, since a European-priced mark can still
legitimately breach intrinsic-adjacent bounds numerically) and the
ex-dividend assignment alert (which only fires for American-style short
calls, since European options cannot be assigned before expiry). It does
not yet feed a pricing model — an American pricer is deliberately
deferred; see AUD-AMX.`,
    enum: ['European', 'American']
} as const;

export const $Expiration = {
    type: 'object',
    required: ['date', 'dte', 'yte', 'fwd', 'atm_iv', 'options'],
    properties: {
        atm_iv: {
            type: 'number',
            format: 'double'
        },
        date: {
            type: 'string'
        },
        dividend_amounts: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            },
            description: 'Cash amounts matching `dividend_dates`.'
        },
        dividend_dates: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            },
            description: `Underlying's discrete dividend schedule: year fractions from the
valuation date. Shared by every expiration of the surface; the
American tree escrows the in-life part.`
        },
        dte: {
            type: 'integer',
            format: 'int32'
        },
        exercise_style: {
            '$ref': '#/components/schemas/ExerciseStyle',
            description: `Early-exercise style resolved for (symbol, expiration); shared by every
strike in this expiration. Defaults to American on legacy payloads.`
        },
        fwd: {
            type: 'number',
            format: 'double'
        },
        is_interpolated: {
            type: 'boolean',
            description: `True if this expiration was interpolated/extrapolated from adjacent DTEs,
not from actual option chain data for this date.`
        },
        options: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/OptionRow'
            }
        },
        skew_25d: {
            type: ['number', 'null'],
            format: 'double',
            description: '25-delta skew (put IV - call IV). None when one wing is missing or unmeasurable.'
        },
        style_provenance: {
            '$ref': '#/components/schemas/StyleProvenance',
            description: `How \`exercise_style\` was sourced for this expiration (IPF map, stale
cache, or built-in fallback). Defaults to Fallback on legacy payloads.`
        },
        yte: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $ExpirationSummary = {
    type: 'object',
    description: 'Summary of an expiration for display.',
    required: ['date', 'dte', 'atm_iv'],
    properties: {
        atm_iv: {
            type: 'number',
            format: 'double'
        },
        date: {
            type: 'string'
        },
        dte: {
            type: 'integer',
            format: 'int32'
        },
        skew_25d: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $ExpirySelector = {
    oneOf: [
        {
            type: 'object',
            required: ['month'],
            properties: {
                month: {
                    type: 'string'
                }
            }
        },
        {
            type: 'object',
            properties: {
                dte_max: {
                    type: ['integer', 'null'],
                    format: 'int32'
                },
                dte_min: {
                    type: ['integer', 'null'],
                    format: 'int32'
                }
            }
        },
        {
            type: 'string'
        }
    ]
} as const;

export const $FitQuality = {
    type: 'object',
    required: ['overall_rmse', 'max_slice_rmse', 'worst_slice_dte'],
    properties: {
        max_slice_rmse: {
            type: 'number',
            format: 'double'
        },
        overall_rmse: {
            type: 'number',
            format: 'double'
        },
        worst_slice_dte: {
            type: 'integer',
            format: 'int32'
        }
    }
} as const;

export const $Forecast = {
    type: 'object',
    required: ['current_atm', 'forecast_1d', 'forecast_5d', 'forecast_low', 'forecast_high', 'direction', 'confidence', 'mr_target', 'model'],
    properties: {
        adjusted_mr_speed: {
            type: 'number',
            format: 'double',
            description: 'MR speed after impulse adjustment (for diagnostics).'
        },
        confidence: {
            type: 'number',
            format: 'double'
        },
        current_atm: {
            type: 'number',
            format: 'double'
        },
        direction: {
            '$ref': '#/components/schemas/ForecastDirection'
        },
        forecast_1d: {
            type: 'number',
            format: 'double'
        },
        forecast_5d: {
            type: 'number',
            format: 'double'
        },
        forecast_high: {
            type: 'number',
            format: 'double'
        },
        forecast_low: {
            type: 'number',
            format: 'double'
        },
        model: {
            type: 'string'
        },
        mr_target: {
            type: 'number',
            format: 'double'
        },
        spot_impulse_strength: {
            type: 'number',
            format: 'double',
            description: 'Spot impulse strength at forecast time (for diagnostics).'
        },
        spot_vol_beta_confidence: {
            type: 'number',
            format: 'double',
            description: 'Confidence score of spot-vol beta prediction (0.0-1.0).'
        },
        spot_vol_beta_source: {
            '$ref': '#/components/schemas/SpotVolBetaSource',
            description: 'Source of spot-vol beta prediction for auditability.'
        }
    }
} as const;

export const $ForecastDirection = {
    type: 'string',
    description: `Forecast direction — up, down, or flat.
Separate from \`Direction\` (Bullish/Bearish/Neutral) in direction.rs
since this applies to vol forecast movement, not strategy direction.`,
    enum: ['up', 'down', 'flat']
} as const;

export const $ForecastWithCI = {
    type: 'object',
    description: 'Forecast result with confidence interval.',
    required: ['point_estimate', 'lower_bound', 'upper_bound', 'confidence_level'],
    properties: {
        confidence_level: {
            type: 'number',
            format: 'double'
        },
        lower_bound: {
            type: 'number',
            format: 'double'
        },
        point_estimate: {
            type: 'number',
            format: 'double'
        },
        upper_bound: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $ForwardVol = {
    type: 'object',
    description: 'Forward vol between two tenor points.',
    required: ['short_tenor', 'long_tenor', 'forward_iv', 'term_slope', 'event_flag'],
    properties: {
        event_flag: {
            type: 'boolean',
            description: 'true if forward_iv / short_atm_iv > 1.5 (possible event)'
        },
        forward_iv: {
            type: 'number',
            format: 'double'
        },
        long_tenor: {
            type: 'array',
            items: false,
            prefixItems: [
                {
                    type: 'integer',
                    format: 'int32'
                },
                {
                    type: 'number',
                    format: 'double'
                }
            ],
            description: '(long_dte, long_atm_iv)'
        },
        short_tenor: {
            type: 'array',
            items: false,
            prefixItems: [
                {
                    type: 'integer',
                    format: 'int32'
                },
                {
                    type: 'number',
                    format: 'double'
                }
            ],
            description: '(short_dte, short_atm_iv)'
        },
        term_slope: {
            '$ref': '#/components/schemas/TermSlope'
        }
    }
} as const;

export const $ForwardVolData = {
    type: 'object',
    description: 'Forward vol data for visualization.',
    required: ['front_expiration', 'back_expiration', 'strikes', 'forward_ivs', 'forward_dte'],
    properties: {
        back_expiration: {
            type: 'string'
        },
        forward_dte: {
            type: 'integer',
            format: 'int32'
        },
        forward_ivs: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        },
        front_expiration: {
            type: 'string'
        },
        strikes: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        }
    }
} as const;

export const $ForwardVolPair = {
    type: 'object',
    description: 'Forward volatility between two consecutive expirations.',
    required: ['short_dte', 'long_dte', 'short_iv', 'long_iv', 'forward_vol_dirty', 'forward_vol_clean', 'is_valid'],
    properties: {
        forward_vol_clean: {
            type: 'number',
            format: 'double'
        },
        forward_vol_dirty: {
            type: 'number',
            format: 'double'
        },
        is_valid: {
            type: 'boolean'
        },
        long_dte: {
            type: 'integer',
            format: 'int32'
        },
        long_iv: {
            type: 'number',
            format: 'double'
        },
        short_dte: {
            type: 'integer',
            format: 'int32'
        },
        short_iv: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $FundingDecompositionResult = {
    type: 'object',
    description: 'Per-expiry funding decomposition result.',
    required: ['expiration', 'yte', 'spot', 'treasury_rate', 'spot_carry_forward', 'parity_forward', 'selected_forward', 'selected_forward_source', 'implied_carry', 'funding_spread_bps', 'parity_vs_spot_carry_bps', 'dividend_event_count', 'ex_div_in_expiry', 'n_strikes_used', 'funding_quality', 'is_outlier'],
    properties: {
        borrow_residual_bps: {
            type: ['number', 'null'],
            format: 'double'
        },
        dividend_adjusted_forward: {
            type: ['number', 'null'],
            format: 'double'
        },
        dividend_event_count: {
            type: 'integer',
            minimum: 0
        },
        dividend_yield: {
            type: ['number', 'null'],
            format: 'double'
        },
        ex_div_in_expiry: {
            type: 'boolean'
        },
        expiration: {
            type: 'string'
        },
        fallback_reason: {
            type: ['string', 'null']
        },
        funding_quality: {
            '$ref': '#/components/schemas/FundingQuality'
        },
        funding_spread_bps: {
            type: 'number',
            format: 'double'
        },
        implied_carry: {
            type: 'number',
            format: 'double'
        },
        is_outlier: {
            type: 'boolean'
        },
        n_strikes_used: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        },
        parity_forward: {
            type: 'number',
            format: 'double'
        },
        parity_rmse_bps: {
            type: ['number', 'null'],
            format: 'double'
        },
        parity_vs_dividend_carry_bps: {
            type: ['number', 'null'],
            format: 'double'
        },
        parity_vs_spot_carry_bps: {
            type: 'number',
            format: 'double'
        },
        selected_forward: {
            type: 'number',
            format: 'double'
        },
        selected_forward_source: {
            type: 'string'
        },
        spot: {
            type: 'number',
            format: 'double'
        },
        spot_carry_forward: {
            type: 'number',
            format: 'double'
        },
        treasury_rate: {
            type: 'number',
            format: 'double'
        },
        yte: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $FundingDecompositionSummary = {
    type: 'object',
    description: 'Funding decomposition summary for all expiries in the analysis.',
    required: ['slices', 'overall_quality'],
    properties: {
        overall_quality: {
            '$ref': '#/components/schemas/FundingQuality'
        },
        slices: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FundingDecompositionResult'
            }
        }
    }
} as const;

export const $FundingQuality = {
    type: 'string',
    enum: ['High', 'Medium', 'Low', 'Reject']
} as const;

export const $GARCHParams = {
    type: 'object',
    description: 'GARCH(1,1) term structure parameters.',
    required: ['sigma_i', 'sigma_final', 'half_life'],
    properties: {
        half_life: {
            type: 'number',
            format: 'double'
        },
        sigma_final: {
            type: 'number',
            format: 'double'
        },
        sigma_i: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $GeometrySpec = {
    type: 'object',
    properties: {
        far_wing: {
            type: ['number', 'null'],
            format: 'double'
        },
        near_wing: {
            type: ['number', 'null'],
            format: 'double'
        },
        ratio: {
            type: ['array', 'null'],
            items: {
                type: 'integer',
                format: 'int32',
                minimum: 0
            }
        },
        width: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/WidthBound'
                }
            ]
        }
    }
} as const;

export const $GreekAxis = {
    type: 'string',
    enum: ['gamma', 'theta', 'vega']
} as const;

export const $GreekProfile = {
    type: 'object',
    properties: {
        delta: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/DeltaTarget'
                }
            ]
        },
        gamma: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/VolDirection'
                }
            ]
        },
        rho: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/VolDirection'
                }
            ]
        },
        theta: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/VolDirection'
                }
            ]
        },
        vega: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/VolDirection'
                }
            ]
        }
    }
} as const;

export const $GreeksBounds = {
    type: 'object',
    properties: {
        delta: {
            type: ['array', 'null'],
            items: false,
            prefixItems: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    type: 'number',
                    format: 'double'
                }
            ]
        },
        gamma: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ThetaBound'
                }
            ]
        },
        rho: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ThetaBound'
                }
            ]
        },
        theta: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ThetaBound'
                }
            ]
        },
        vega: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ThetaBound'
                }
            ]
        }
    }
} as const;

export const $Highlights = {
    type: 'object',
    required: ['premium', 'volume', 'gamma', 'movers'],
    properties: {
        gamma: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/UnderlyingHighlight'
            }
        },
        movers: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MoveHighlight'
            }
        },
        premium: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ContractHighlight'
            }
        },
        volume: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/UnderlyingHighlight'
            }
        }
    }
} as const;

export const $HiroAggSummary = {
    type: 'object',
    required: ['volume', 'premium', 'delta', 'gamma', 'vega'],
    properties: {
        delta: {
            '$ref': '#/components/schemas/PutCallVal'
        },
        gamma: {
            '$ref': '#/components/schemas/PutCallVal'
        },
        premium: {
            '$ref': '#/components/schemas/PutCallVal'
        },
        vega: {
            '$ref': '#/components/schemas/PutCallVal'
        },
        volume: {
            '$ref': '#/components/schemas/PutCallVal'
        }
    }
} as const;

export const $HiroStreamString = {
    type: 'string',
    enum: ['filtered', 'absolute']
} as const;

export const $IVLevel = {
    type: 'string',
    description: 'IV level classification.',
    enum: ['low', 'normal', 'high', 'extreme']
} as const;

export const $IVSurface = {
    type: 'object',
    required: ['symbol', 'trade_date', 'spot', 'expirations'],
    properties: {
        expirations: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Expiration'
            }
        },
        spot: {
            type: 'number',
            format: 'double'
        },
        symbol: {
            type: 'string'
        },
        trade_date: {
            type: 'string'
        }
    }
} as const;

export const $IntradayBarType = {
    type: 'string',
    enum: ['oi', 'gamma']
} as const;

export const $IntradayGreek = {
    type: 'string',
    enum: ['delta', 'gamma']
} as const;

export const $IpfExerciseStyle = {
    type: 'string',
    enum: ['european', 'american']
} as const;

export const $KeyLevel = {
    type: 'object',
    description: 'Support/resistance level.',
    required: ['price', 'level_type', 'entity', 'strength'],
    properties: {
        entity: {
            type: 'string'
        },
        level_type: {
            type: 'string'
        },
        price: {
            type: 'number',
            format: 'double'
        },
        strength: {
            type: 'string'
        }
    }
} as const;

export const $Leg = {
    type: 'object',
    required: ['strike', 'expiry', 'option_type', 'action', 'price', 'delta', 'gamma', 'theta', 'vega'],
    properties: {
        action: {
            '$ref': '#/components/schemas/Action'
        },
        delta: {
            type: 'number',
            format: 'double'
        },
        exercise_style: {
            '$ref': '#/components/schemas/ExerciseStyle',
            description: `Early-exercise classification for this leg's underlying. Distinct
from \`pricing_model\`: an American-classified leg can still price via
Black-76 when the early-exercise gate does not fire. Defaults to
American on legacy payloads.`
        },
        expiry: {
            type: 'string'
        },
        gamma: {
            type: 'number',
            format: 'double'
        },
        multiplier: {
            type: 'number',
            format: 'double',
            description: `Shares per contract: 100 for standard US equity options; index/mini
products vary. Dollar exposure = price * multiplier (price is
already the total for quantity contracts).`
        },
        option_type: {
            '$ref': '#/components/schemas/OptionType'
        },
        price: {
            type: 'number',
            format: 'double'
        },
        pricing_model: {
            '$ref': '#/components/schemas/PricingModel',
            description: `Which pricing model produced \`price\` (Black-76 closed-form or the
American CRR tree). Defaults to Black76 on legacy payloads.`
        },
        quantity: {
            type: 'integer',
            format: 'int32',
            description: `Number of contracts for this leg (>=1). All scanner legs are single
contract, so quantity is 1; the field makes units explicit and mirrors
the catalog/gen Leg. price/delta/gamma/theta/vega remain TOTAL values
for all \`quantity\` contracts.`
        },
        strike: {
            type: 'number',
            format: 'double'
        },
        style_provenance: {
            '$ref': '#/components/schemas/StyleProvenance',
            description: 'How `exercise_style` was sourced (IPF map, stale cache, fallback).'
        },
        theta: {
            type: 'number',
            format: 'double'
        },
        vega: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $LegRatio = {
    type: 'object',
    required: ['body', 'middle', 'far'],
    properties: {
        body: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        },
        far: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        },
        middle: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        }
    }
} as const;

export const $MLFeatureSnapshot = {
    type: 'object',
    description: 'Serializable snapshot of ML features extracted from the pipeline.',
    required: ['trend_strength', 'returns', 'z_scores', 'volatility_features', 'rv_d50_spread', 'garch_rank', 'call_wing_slope_rank', 'put_wing_slope_rank', 'butterfly_rank', 'normalized_skew_rank', 'trend_consistency', 'movement_extremity'],
    properties: {
        butterfly_rank: {
            type: 'number',
            format: 'double'
        },
        call_wing_slope_rank: {
            type: 'number',
            format: 'double'
        },
        garch_rank: {
            type: 'number',
            format: 'double'
        },
        movement_extremity: {
            type: 'number',
            format: 'double'
        },
        normalized_skew_rank: {
            type: 'number',
            format: 'double'
        },
        put_wing_slope_rank: {
            type: 'number',
            format: 'double'
        },
        returns: {
            '$ref': '#/components/schemas/MLReturns'
        },
        rv_d50_spread: {
            type: 'number',
            format: 'double'
        },
        trend_consistency: {
            type: 'number',
            format: 'double'
        },
        trend_strength: {
            '$ref': '#/components/schemas/MLTrendStrength'
        },
        volatility_features: {
            '$ref': '#/components/schemas/MLVolatilityFeatures'
        },
        z_scores: {
            '$ref': '#/components/schemas/MLZScores'
        }
    }
} as const;

export const $MLReturns = {
    type: 'object',
    description: 'Returns vs SMA sub-struct for JSON nesting.',
    required: ['short_term_return', 'medium_term_return', 'long_term_return', 'short_term_above_sma', 'medium_term_above_sma', 'long_term_above_sma'],
    properties: {
        long_term_above_sma: {
            type: 'number',
            format: 'double'
        },
        long_term_return: {
            type: 'number',
            format: 'double'
        },
        medium_term_above_sma: {
            type: 'number',
            format: 'double'
        },
        medium_term_return: {
            type: 'number',
            format: 'double'
        },
        short_term_above_sma: {
            type: 'number',
            format: 'double'
        },
        short_term_return: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $MLTrendStrength = {
    type: 'object',
    description: 'Trend strength sub-struct for JSON nesting.',
    required: ['strength', 'consecutive_moves', 'direction'],
    properties: {
        consecutive_moves: {
            type: 'number',
            format: 'double'
        },
        direction: {
            type: 'string'
        },
        strength: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $MLVolatilityFeatures = {
    type: 'object',
    description: 'Volatility features sub-struct for JSON nesting.',
    required: ['iv_rank', 'skew_rank', 'wing_steepness_rank_d95_v_d10', 'rv', 'd50', 'convexity_rank'],
    properties: {
        convexity_rank: {
            type: 'number',
            format: 'double'
        },
        d50: {
            type: 'number',
            format: 'double'
        },
        iv_rank: {
            type: 'number',
            format: 'double'
        },
        rv: {
            type: 'number',
            format: 'double'
        },
        skew_rank: {
            type: 'number',
            format: 'double'
        },
        wing_steepness_rank_d95_v_d10: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $MLZScores = {
    type: 'object',
    description: 'Z-scores sub-struct for JSON nesting.',
    required: ['short_term_zscore', 'medium_term_zscore', 'long_term_zscore'],
    properties: {
        long_term_zscore: {
            type: 'number',
            format: 'double'
        },
        medium_term_zscore: {
            type: 'number',
            format: 'double'
        },
        short_term_zscore: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $Manifest = {
    type: 'object',
    required: ['underlyings', 'combos'],
    properties: {
        combos: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ComboSet'
            }
        },
        underlyings: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    }
} as const;

export const $MarketActorKind = {
    type: 'string',
    enum: ['cust', 'procust', 'mm', 'firm', 'bd']
} as const;

export const $MaxRiskKind = {
    type: 'string',
    description: `AUD26-SE09: classifies whether a \`Strategy\`'s \`max_risk\` is a true
payoff bound (\`Bound\`, the pre-existing meaning for every strategy) or a
VIEW-01 stress estimate (\`Stress\` -- currently only the six
calendar/diagonal names, and only when \`view_pnl\` is \`Some\`). Consumers
(CLI text card, JSON) MUST check this before presenting \`max_risk\` as
"Max Risk" -- see \`StrategyRef::is_calendar_or_diagonal\`.`,
    enum: ['bound', 'stress']
} as const;

export const $Membership = {
    type: 'string',
    enum: ['Standard', 'Pro', 'Alpha']
} as const;

export const $MispricedPoint = {
    type: 'object',
    description: 'Single mispriced option point with computed z-score.',
    required: ['strike', 'expiry', 'dte', 'option_type', 'market_iv', 'fair_iv', 'zscore', 'price', 'delta', 'side'],
    properties: {
        delta: {
            type: 'number',
            format: 'double'
        },
        dte: {
            type: 'integer',
            format: 'int32'
        },
        expiry: {
            type: 'string'
        },
        fair_iv: {
            type: 'number',
            format: 'double'
        },
        market_iv: {
            type: 'number',
            format: 'double'
        },
        option_type: {
            type: 'string'
        },
        price: {
            type: 'number',
            format: 'double'
        },
        side: {
            type: 'string'
        },
        strike: {
            type: 'number',
            format: 'double'
        },
        zscore: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $ModerationInputType = {
    type: 'string',
    enum: ['text', 'image']
} as const;

export const $ModerationResultBody = {
    type: 'object',
    description: 'A moderation result produced for the response input or output.',
    required: ['type', 'model', 'flagged', 'categories', 'category_scores', 'category_applied_input_types'],
    properties: {
        categories: {
            type: 'object',
            description: 'A dictionary of moderation categories to booleans, True if the input is flagged under this category.',
            additionalProperties: {
                type: 'boolean'
            },
            propertyNames: {
                type: 'string'
            }
        },
        category_applied_input_types: {
            type: 'object',
            description: 'Which modalities of input are reflected by the score for each category.',
            additionalProperties: {
                type: 'array',
                items: {
                    '$ref': '#/components/schemas/ModerationInputType'
                }
            },
            propertyNames: {
                type: 'string'
            }
        },
        category_scores: {
            type: 'object',
            description: 'A dictionary of moderation categories to scores.',
            additionalProperties: {
                type: 'number',
                format: 'double'
            },
            propertyNames: {
                type: 'string'
            }
        },
        flagged: {
            type: 'boolean',
            description: 'A boolean indicating whether the contenChatCompletionStreamResponseDeltat was flagged by any category.'
        },
        model: {
            type: 'string',
            description: 'The moderation model that produced this result.'
        },
        type: {
            '$ref': '#/components/schemas/ModerationResultBodyType',
            description: 'The object type, which was always `moderation_result` for successful moderation results.'
        }
    }
} as const;

export const $ModerationResultBodyType = {
    type: 'string',
    description: 'The object type, which was always `moderation_result` for successful moderation results.',
    enum: ['moderation_result']
} as const;

export const $MoveHighlight = {
    type: 'object',
    required: ['underlying', 'last_close', 'close'],
    properties: {
        close: {
            type: 'number',
            format: 'double'
        },
        last_close: {
            type: 'number',
            format: 'double'
        },
        underlying: {
            type: 'string'
        }
    }
} as const;

export const $MoviefoneAnalysis = {
    type: 'object',
    description: 'Top-level JSON shape returned by moviefone analysis.',
    required: ['symbol', 'trade_date', 'spot', 'regime', 'enriched_regime', 'volatility', 'forecast', 'mispriced_options', 'strategies', 'strategy_catalog', 'candidate_tables', 'dollar_value_contracts', 'dollar_value_summaries', 'pre_enforcement_surface', 'hold_days'],
    properties: {
        arbitrage_enforcement: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ArbitrageEnforcementResult'
                }
            ]
        },
        atm_tenor_backtest: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/AtmTenorBacktestSummary',
                    description: 'ATM tenor backtest results (computed by CLI after analysis).'
                }
            ]
        },
        candidate_tables: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CandidateTable'
            }
        },
        correlation_regime: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/CorrelationOutput',
                    description: 'Correlation regime detection output.'
                }
            ]
        },
        cross_risk_adjustments: {
            type: ['array', 'null'],
            items: {
                '$ref': '#/components/schemas/CrossRiskTenorAdjustment'
            },
            description: 'Per-tenor cross-risk adjustments showing what bumps were applied.'
        },
        cross_risk_events: {
            type: ['array', 'null'],
            items: {
                '$ref': '#/components/schemas/PeerEventSignal'
            },
            description: 'Cross-risk peer events applied during projection.'
        },
        dollar_value_contracts: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DollarValuePerContract'
            }
        },
        dollar_value_summaries: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DollarValueSummary'
            }
        },
        enriched_regime: {
            '$ref': '#/components/schemas/EnrichedRegime'
        },
        event_adjusted_vrp: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/EventAdjustedVrp',
                    description: `Event-adjusted VRP decomposition (additive display only). None when no
upcoming earnings event lies inside the headline tenor or extraction fails.`
                }
            ]
        },
        event_source: {
            type: ['string', 'null'],
            description: 'Provenance of the event signal: "calendar", "geometry" or "peer".'
        },
        excluded_by_conditioning: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ExclusionRecord'
            },
            description: `SE-05: per-candidate exclusions applied by \`apply_stance_conditioning\`, in
encounter order. Empty (not omitted) when conditioning ran but excluded
nothing, so callers can distinguish "ran, nothing excluded" from "did not run".`
        },
        forecast: {
            '$ref': '#/components/schemas/Forecast'
        },
        funding_decomposition: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/FundingDecompositionSummary',
                    description: 'Funding decomposition summary for each expiry.'
                }
            ]
        },
        hold_days: {
            type: 'integer',
            format: 'int32'
        },
        mispriced_options: {
            '$ref': '#/components/schemas/ScanResult'
        },
        ml_features: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/MLFeatureSnapshot'
                }
            ]
        },
        pre_enforcement_surface: {
            '$ref': '#/components/schemas/IVSurface'
        },
        projected_surface: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ProjectedSurface'
                }
            ]
        },
        regime: {
            '$ref': '#/components/schemas/RegimeResult'
        },
        requested_direction: {
            type: ['string', 'null']
        },
        scenario_forecast: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ScenarioForecast'
                }
            ]
        },
        scenario_pricing: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ScenarioPricingSummary',
                    description: 'Scenario pricing under user-specified spot/DTE.'
                }
            ]
        },
        skew_backtest: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/SkewBacktestSummary',
                    description: 'Skew backtest results (computed by CLI after analysis).'
                }
            ]
        },
        skew_plot_data: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/SkewPlotResponse'
                }
            ]
        },
        spot: {
            type: 'number',
            format: 'double'
        },
        spot_vol_regime: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/SpotVolRegime'
                }
            ]
        },
        spot_vol_surface: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/SpotVolSurfaceBeta',
                    description: 'SURF-01: calibrated full-surface spot-vol response (per-tenor + skew).'
                }
            ]
        },
        stance_conditioning: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/StanceConditioning',
                    description: `COND-01 stance conditioning verdict (event zone, corr bucket, slope/skew tiers,
skew rich/cheap verdict, block reasons). None when conditioning is unavailable.`
                }
            ]
        },
        strategies: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Strategy'
            }
        },
        strategy_catalog: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ScoredStrategy'
            }
        },
        strategy_rules: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/RulesResult'
                }
            ]
        },
        structure_search: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/StructureSearchResult'
                }
            ]
        },
        surface_edge: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/SurfaceEdgeResult'
                }
            ]
        },
        surface_residuals: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/SurfaceResiduals'
                }
            ]
        },
        svi_surface: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/SviSurfaceSummary'
                }
            ]
        },
        symbol: {
            type: 'string'
        },
        synth_oi: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/SyntheticOIInput',
                    description: 'Synthetic OI data (passed through from input).'
                }
            ]
        },
        term_structure_backtest: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/TermStructureBacktestSummary',
                    description: 'Term-structure forecast diagnostics (slopes + curvatures).'
                }
            ]
        },
        trade_date: {
            type: 'string'
        },
        tvtp_filtered_state: {
            type: ['array', 'null'],
            items: {
                type: 'number',
                format: 'double'
            },
            description: 'Persisted TVTP filtered state for next analysis run.'
        },
        tvtp_regime: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/TVTPOutput'
                }
            ]
        },
        view: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/View',
                    description: `VIEW-01: the user's directional view, derived from \`future_spot\`/
\`days_ahead\`. Explicitly \`None\` (serialized, not omitted) when no
view was supplied -- callers must distinguish "no view" from "old
client, field never existed". When \`None\`, the ranked \`strategies\`
list is view-free (catalog/regime scores and view-free POP only);
when \`Some\`, every entry is view-conditional.`
                }
            ]
        },
        vol_forecast: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/VolForecastResult'
                }
            ]
        },
        vol_surface_3d: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/VolatilitySurface3D'
                }
            ]
        },
        volatility: {
            '$ref': '#/components/schemas/VolatilitySnapshot'
        },
        vrp_term_structure: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/VRPTermStructure'
                }
            ]
        }
    }
} as const;

export const $MoviefoneChatBody = {
    type: 'object',
    properties: {
        client_side_tools: {
            type: ['array', 'null'],
            items: {
                '$ref': '#/components/schemas/AssistantTool'
            },
            description: `An additional list of tools, sent by the client, which the LLM may invoke
to acheive a tool's outcome, as described in its \`description\` field

Used experimentally, for new toolcalls from frontend.  Calls should
eventually be migrated to TOOL_DEFINITIONS in the backend`,
            example: `[{"type":"function","function":{"name":"get_vol_forecast","description":"Get volatility forecast for a ticker. Includes current IV, forecasted IV at different horizons, and directional confidence.","parameters":{"properties":{"ticker":{"description":"Ticker symbol (e.g., SPY, AAPL)","type":"string"}},"required":["ticker"],"type":"object"}}},{"type":"function","function":{"name":"get_vrp_term_structure","description":"Multi-tenor VRP table for a ticker: ATM IV vs realized vol at 7, 14, 21, 30, 45, 60, 90 DTE.","parameters":{"properties":{"ticker":{"description":"Ticker symbol","type":"string"}},"required":["ticker"],"type":"object"}}},{"type":"function","function":{"name":"get_regime_status","description":"Get the current vol regime {Derman/TVTP}}, VRP snapshot, and confidence levels for a ticker.","parameters":{"properties":{"ticker":{"description":"Ticker symbol","type":"string"}},"required":["ticker"],"type":"object"}}},{"type":"function","function":{"name":"get_implied_earnings_move","description":"Detect if there is an earnings event implied in the vol surface and return its characteristics.","parameters":{"properties":{"ticker":{"description":"Ticker symbol","type":"string"}},"required":["ticker"],"type":"object"}}},{"type":"function","function":{"name":"get_sgoi_positioning","description":"Get synthetic OI positioning data: customer/firm/market-maker activity, IV rank, skew rank, and key levels.","parameters":{"properties":{"ticker":{"description":"Ticker symbol","type":"string"}},"required":["ticker"],"type":"object"}}},{"type":"function","function":{"name":"get_scenario_pnl","description":"Compute a P&L grid for a multi-leg position across spot and vol shocks using Black-76 pricing.","parameters":{"properties":{"legs":{"description":"Array of option legs with strike, call_or_put, expiration, quantity, entry_price","items":{"type":"object"},"type":"array"},"spot_shocks_pct":{"description":"Spot shock percentages (e.g., [-0.10, -0.05, 0, 0.05, 0.10])","items":{"type":"number"},"type":"array"},"vol_shocks_vpts":{"description":"Vol shock in vols (e.g., [-0.05, -0.02, 0, 0.02, 0.05])","items":{"type":"number"},"type":"array"}},"required":["legs"],"type":"object"}}},{"type":"function","function":{"name":"get_surface_edge_recommendation","description":"Get surface edge recommendations based on spot change and vol signal. Returns top spreads and legs.","parameters":{"properties":{"hold_days":{"description":"Holding period in days (default 5)","type":"number"},"spot_change_pct":{"description":"Expected spot change percentage","type":"number"},"vol_signal":{"description":"Vol signal: short_vol or long_vol","type":"string"}},"required":["spot_change_pct"],"type":"object"}}},{"type":"function","function":{"name":"get_strategy_recommendation","description":"Get the top 3 recommended strategies with their legs, Greeks, and rationale.","parameters":{"properties":{"ticker":{"description":"Ticker symbol","type":"string"}},"required":["ticker"],"type":"object"}}},{"type":"function","function":{"name":"get_available_strategies","description":"Get the full strategy catalog with names, categories, and scores.","parameters":{"properties":{"ticker":{"description":"Ticker symbol","type":"string"}},"required":["ticker"],"type":"object"}}},{"type":"function","function":{"name":"build_spotgamma_link","description":"Build a Spotgamma options calculator link for a set of option legs.","parameters":{"properties":{"legs":{"description":"Option legs with expiration, call_or_put, strike, quantity, premium","items":{"type":"object"},"type":"array"},"symbol":{"description":"Ticker symbol","type":"string"}},"required":["symbol","legs"],"type":"object"}}},{"type":"function","function":{"name":"patch_trade_criteria","description":"Patches a user's trade criteria state on their client. The components of the trade criteria are the parameters to this toolcall. Display on the client side only.","parameters":{"properties":{"direction":{"description":"'Bullish', 'Neutral', or 'Bearish'","type":"string"},"max_pnl_ratio":{"description":"Maximum acceptable profit/loss ratio. Some number from 0-99 or infinity","type":"number"},"min_pnl_ratio":{"description":"Minimum acceptable profit/loss ratio. Some number from 0-99 or infinity","type":"number"},"riskTolerance":{"description":"'low', 'medium', or 'high'","type":"string"},"symbol":{"description":"The ticker symbol of the stock that the user is interested in.","type":"string"},"timeFrameDays":{"description":"Goal timeframe for any options they're interested in. May be 1-90 days.","type":"string"}},"required":["symbol"],"type":"object"}}}]`
        },
        conversation: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ChatMessage'
            }
        },
        gatekeeper_model_override: {
            type: ['string', 'null']
        },
        gatekeeper_prompt_override: {
            type: ['string', 'null']
        },
        moviefone_json: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/MoviefoneAnalysis'
                }
            ]
        },
        primary_model_override: {
            type: ['string', 'null']
        },
        primary_prompt_override: {
            type: ['string', 'null']
        },
        user_message: {
            type: ['string', 'null']
        }
    }
} as const;

export const $MoviefoneChatFollowupRsp = {
    type: 'object',
    required: ['content'],
    properties: {
        content: {
            type: 'string'
        }
    }
} as const;

export const $MoviefoneConversationSummary = {
    type: 'object',
    required: ['timestamp', 'title', 'last_interacted'],
    properties: {
        last_interacted: {
            type: 'string',
            description: `RFC 3339 UTC. When the caller last explicitly interacted with this conversation (asked
a question) - controls list order. Doesn't move just because a response finished
generating; only a save marked via \`x-moviefone-interacted\` bumps it.`
        },
        timestamp: {
            type: 'string',
            description: `Identifier used to load/overwrite/delete this conversation - stays fixed for its
lifetime, even as \`last_interacted\` moves forward.`
        },
        title: {
            type: 'string'
        }
    }
} as const;

export const $NetGreeks = {
    type: 'object',
    description: `# Greeks units convention (authoritative)

All Greeks in this crate follow the standard Black-76 textbook convention,
matching \`OptionPricer::black76()\` (see \`option_pricer.rs\`) exactly:

- \`delta\`, \`gamma\`: standard, unitless-per-share sensitivities.
- \`theta\`: **annualized** decay (dV/dT, T in years). To get a
  per-calendar-day figure, divide by \`CALENDAR_DAYS_IN_YEAR\` (365.0, see
  \`schedule.rs\`).
- \`vega\`: sensitivity **per 1.00 vol point** (dV/dσ, σ in decimal, e.g.
  0.20 for 20% IV). To get a per-1%-vol-move figure, divide by 100.

These are RAW per-share, per-contract-quantity-in-the-struct totals (see
\`Leg\`'s own doc comment for the price/quantity/multiplier convention). Any
code that converts to daily theta or per-1% vega (e.g.
\`strategy::helpers::compute_carry\`) does so explicitly and locally; the
struct fields below never do this conversion themselves.

Net Greeks aggregated across all legs of a strategy.
Buy => +1.0 * leg Greek; Sell => -1.0 * leg Greek.`,
    required: ['delta', 'gamma', 'theta', 'vega'],
    properties: {
        delta: {
            type: 'number',
            format: 'double',
            description: 'Net delta exposure across all legs.'
        },
        gamma: {
            type: 'number',
            format: 'double',
            description: 'Net gamma exposure across all legs.'
        },
        theta: {
            type: 'number',
            format: 'double',
            description: `Net theta exposure across all legs, annualized (per year). See the
units convention doc above; divide by 365 for a per-calendar-day figure.`
        },
        vega: {
            type: 'number',
            format: 'double',
            description: `Net vega exposure across all legs, per 1.00 vol point. See the units
convention doc above; divide by 100 for a per-1%-vol-move figure.`
        }
    }
} as const;

export const $OaAnnotation = {
    type: 'object',
    properties: {
        confirming: {
            type: ['string', 'null']
        },
        level: {
            type: ['string', 'null']
        },
        suggestion: {
            type: ['string', 'null']
        },
        warning: {
            type: ['string', 'null']
        }
    }
} as const;

export const $OpenLeg = {
    type: 'object',
    properties: {
        action: {
            type: ['string', 'null']
        },
        expiry: {
            type: ['string', 'null']
        },
        option_type: {
            type: ['string', 'null']
        },
        quantity: {
            type: ['integer', 'null'],
            format: 'int32'
        },
        strike: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $OpeningSetupPositionMove = {
    type: 'object',
    required: ['id', 'report_date', 'underlying', 'created_at'],
    properties: {
        buy_to_close: {
            type: ['number', 'null'],
            format: 'double'
        },
        buy_to_open: {
            type: ['number', 'null'],
            format: 'double'
        },
        call_or_put: {
            type: ['string', 'null']
        },
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        current_total_volume: {
            type: ['number', 'null'],
            format: 'double'
        },
        cust_buy_premium: {
            type: ['number', 'null'],
            format: 'double'
        },
        cust_sell_premium: {
            type: ['number', 'null'],
            format: 'double'
        },
        est_option_px: {
            type: ['number', 'null'],
            format: 'double'
        },
        expiration_date: {
            type: ['string', 'null'],
            format: 'date'
        },
        extra: {},
        id: {
            type: 'integer',
            format: 'int64'
        },
        iv_rank: {
            type: ['number', 'null'],
            format: 'double'
        },
        ivmean: {
            type: ['number', 'null'],
            format: 'double'
        },
        multileg_desc: {
            type: ['string', 'null']
        },
        multileg_id: {
            type: ['integer', 'null'],
            format: 'int32'
        },
        open_interest: {
            type: ['number', 'null'],
            format: 'double'
        },
        open_interest_change: {
            type: ['number', 'null'],
            format: 'double'
        },
        position_type: {
            type: ['string', 'null']
        },
        prob_profit: {
            type: ['number', 'null'],
            format: 'double'
        },
        report_date: {
            type: 'string',
            format: 'date'
        },
        sell_to_close: {
            type: ['number', 'null'],
            format: 'double'
        },
        sell_to_open: {
            type: ['number', 'null'],
            format: 'double'
        },
        skew_rank: {
            type: ['number', 'null'],
            format: 'double'
        },
        stock_price: {
            type: ['number', 'null'],
            format: 'double'
        },
        strike_price: {
            type: ['number', 'null'],
            format: 'double'
        },
        total_abs_premium: {
            type: ['number', 'null'],
            format: 'double'
        },
        total_premium: {
            type: ['number', 'null'],
            format: 'double'
        },
        underlying: {
            type: 'string'
        }
    }
} as const;

export const $OpeningSetupProfile = {
    type: 'object',
    required: ['report_date', 'label', 'symbol', 'created_at'],
    properties: {
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        iv_rank: {
            type: ['number', 'null'],
            format: 'double'
        },
        iv_rv: {
            type: ['number', 'null'],
            format: 'double'
        },
        label: {
            '$ref': '#/components/schemas/SetupProfileLabel'
        },
        report_date: {
            type: 'string',
            format: 'date'
        },
        skew_rank: {
            type: ['number', 'null'],
            format: 'double'
        },
        strategy: {
            type: ['string', 'null']
        },
        symbol: {
            type: 'string'
        }
    }
} as const;

export const $OpeningSetupVolScanner = {
    type: 'object',
    required: ['report_date', 'sym', 'volume_rank', 'created_at'],
    properties: {
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        iv: {
            type: ['number', 'null'],
            format: 'double'
        },
        iv_chg: {
            type: ['number', 'null'],
            format: 'double'
        },
        iv_percentile: {
            type: ['number', 'null'],
            format: 'double'
        },
        iv_practical_code: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/PracticalCode'
                }
            ]
        },
        iv_practical_read: {
            type: ['string', 'null']
        },
        iv_prev: {
            type: ['number', 'null'],
            format: 'double'
        },
        iv_rank: {
            type: ['number', 'null'],
            format: 'double'
        },
        report_date: {
            type: 'string',
            format: 'date'
        },
        sym: {
            type: 'string'
        },
        total_volume: {
            type: ['number', 'null'],
            format: 'double'
        },
        volume_rank: {
            type: 'integer',
            format: 'int32'
        }
    }
} as const;

export const $OptionAccumulationType = {
    type: 'string',
    enum: ['Calls', 'Puts', 'Total']
} as const;

export const $OptionLeg = {
    type: 'object',
    description: 'Option leg for surface edge analysis.',
    required: ['strike', 'dte', 'is_call', 'exp_str', 'bid', 'ask', 'iv_now', 'iv_scen', 'edge', 'edge_pct', 'moneyness_pct', 'moneyness_vs_target'],
    properties: {
        ask: {
            type: 'number',
            format: 'double'
        },
        bid: {
            type: 'number',
            format: 'double'
        },
        dte: {
            type: 'integer',
            format: 'int32'
        },
        edge: {
            type: 'number',
            format: 'double'
        },
        edge_pct: {
            type: 'number',
            format: 'double'
        },
        exp_str: {
            type: 'string'
        },
        is_call: {
            type: 'boolean'
        },
        iv_now: {
            type: 'number',
            format: 'double'
        },
        iv_scen: {
            type: 'number',
            format: 'double'
        },
        moneyness_pct: {
            type: 'number',
            format: 'double'
        },
        moneyness_vs_target: {
            type: 'number',
            format: 'double'
        },
        strike: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $OptionOrigin = {
    type: 'string',
    enum: ['All', 'NextExpiry', 'Retail']
} as const;

export const $OptionRow = {
    type: 'object',
    required: ['strike', 'log_moneyness', 'call_price', 'put_price', 'source_iv', 'calc_iv', 'call_delta'],
    properties: {
        calc_iv: {
            type: 'number',
            format: 'double'
        },
        call_ask: {
            type: 'number',
            format: 'double'
        },
        call_bid: {
            type: 'number',
            format: 'double'
        },
        call_delta: {
            type: 'number',
            format: 'double'
        },
        call_price: {
            type: 'number',
            format: 'double'
        },
        log_moneyness: {
            type: 'number',
            format: 'double'
        },
        put_ask: {
            type: 'number',
            format: 'double'
        },
        put_bid: {
            type: 'number',
            format: 'double'
        },
        put_delta: {
            type: 'number',
            format: 'double'
        },
        put_price: {
            type: 'number',
            format: 'double'
        },
        source_iv: {
            type: 'number',
            format: 'double'
        },
        strike: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $OptionType = {
    type: 'string',
    enum: ['Call', 'Put', 'Stock']
} as const;

export const $Order = {
    type: 'string',
    enum: ['asc', 'desc']
} as const;

export const $OverlayRegime = {
    type: 'string',
    description: 'Extended regime overlay for regime adaptation.',
    enum: ['HIGH_VOL', 'LOW_VOL', 'PRE_EVENT', 'NORMAL']
} as const;

export const $OwnsShares = {
    oneOf: [
        {
            type: 'integer',
            format: 'int32',
            minimum: 0
        },
        {
            type: 'boolean'
        }
    ]
} as const;

export const $Page_VixQuote = {
    type: 'object',
    required: ['items'],
    properties: {
        items: {
            type: 'array',
            items: {
                allOf: [
                    {
                        '$ref': '#/components/schemas/SymbolCandle'
                    },
                    {
                        type: 'object',
                        required: ['expiration_date'],
                        properties: {
                            expiration_date: {
                                type: 'string',
                                format: 'date'
                            }
                        }
                    }
                ]
            }
        }
    }
} as const;

export const $PeerEventSignal = {
    type: 'object',
    description: "A peer earnings event that affects the target's projection.",
    required: ['event_symbol', 'days_until', 'weight'],
    properties: {
        days_until: {
            type: 'integer',
            format: 'int32',
            description: "Days from as-of to the peer's announcement (sign as in `EarningsEvent`)."
        },
        event_symbol: {
            type: 'string',
            description: 'Who reports (e.g. "NVDA" when projecting AMD).'
        },
        sigma_j_sq: {
            type: ['number', 'null'],
            format: 'double',
            description: `The peer's risk-neutral event variance σ²_j (unitless squared jump
size, e.g. 0.0052 ≈ a 7.2% typical move). None when the peer surface
was unavailable or the term structure could not identify it — the
apply step then skips the event rather than guess.`
        },
        weight: {
            type: 'number',
            format: 'double',
            description: 'Spillover weight w ∈ [0, 1].'
        }
    }
} as const;

export const $PositionMovesRsp = {
    type: 'object',
    required: ['report_date', 'positions'],
    properties: {
        positions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/OpeningSetupPositionMove'
            }
        },
        report_date: {
            type: 'string',
            format: 'date'
        }
    }
} as const;

export const $PracticalCode = {
    type: 'string',
    description: `Machine-readable IV classification on \`opening_setup_vol_scanner\`. Mirrors \`PracticalCode\` in
flow_patrol/opening_print_data.py, which is what writes the column - the \`db_enum\` renames are
that StrEnum's values, so the two must be changed together.`,
    enum: ['clearly_cheap', 'clearly_rich', 'high_pct', 'high_rank', 'low_pct', 'low_rank', 'moderate_iv', 'not_really_cheap', 'range_high_not_extreme', 'somewhat_cheap', 'somewhat_rich', 'unknown']
} as const;

export const $PricingModel = {
    type: 'string',
    enum: ['black76', 'crr']
} as const;

export const $ProjectedExpiration = {
    type: 'object',
    required: ['dte', 'atm_iv'],
    properties: {
        atm_iv: {
            type: 'number',
            format: 'double'
        },
        date: {
            type: ['string', 'null'],
            description: 'Listed expiration date (YYYY-MM-DD). None for extrapolated grid anchors.'
        },
        dte: {
            type: 'integer',
            format: 'int32'
        },
        is_extrapolated: {
            type: 'boolean',
            description: 'True when the point is a model grid tenor beyond the last listed expiration.'
        },
        skew_25d: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $ProjectedSurface = {
    type: 'object',
    required: ['method', 'projected_atm_iv', 'projected_expirations'],
    properties: {
        method: {
            '$ref': '#/components/schemas/ProjectionMethod'
        },
        projected_atm_iv: {
            type: 'number',
            format: 'double'
        },
        projected_expirations: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ProjectedExpiration'
            }
        }
    }
} as const;

export const $ProjectionMethod = {
    type: 'string',
    enum: ['StickyStrike', 'StickyDelta', 'StickySurface', 'CfmBlend']
} as const;

export const $PutCallVal = {
    type: 'object',
    properties: {
        call: {
            type: ['number', 'null'],
            format: 'double'
        },
        put: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $RVEstimatorResult = {
    type: 'object',
    description: `Result of running all RV estimators.

The high-low estimators (Parkinson/GK/YZ/RS) were removed because they had
been fed fabricated OHLC bars derived from \`spot * atm_iv\` (a pure IV echo,
zero independent price information). Only close-to-close is reported, with
the four estimator fields always \`None\`.`,
    required: ['best_estimate', 'best_method'],
    properties: {
        best_estimate: {
            type: 'number',
            format: 'double'
        },
        best_method: {
            type: 'string'
        },
        garman_klass: {
            type: ['number', 'null'],
            format: 'double'
        },
        parkinson: {
            type: ['number', 'null'],
            format: 'double'
        },
        rogers_satchell: {
            type: ['number', 'null'],
            format: 'double'
        },
        yang_zhang: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $RankedCandidate = {
    type: 'object',
    description: 'Ranked option candidate for TOP CANDIDATES table.',
    required: ['rank', 'strike', 'option_type', 'delta', 'iv', 'theta', 'vega', 'tv_ratio', 'score', 'rationale'],
    properties: {
        delta: {
            type: 'number',
            format: 'double'
        },
        iv: {
            type: 'number',
            format: 'double'
        },
        option_type: {
            type: 'string'
        },
        rank: {
            type: 'integer',
            minimum: 0
        },
        rationale: {
            type: 'string'
        },
        score: {
            type: 'number',
            format: 'double'
        },
        strike: {
            type: 'number',
            format: 'double'
        },
        theta: {
            type: 'number',
            format: 'double',
            description: `Black-76 theta, annualized (per year). See units convention in
\`strategies::NetGreeks\` doc comment.`
        },
        tv_ratio: {
            type: 'number',
            format: 'double'
        },
        vega: {
            type: 'number',
            format: 'double',
            description: `Black-76 vega, per 1.00 vol point. See units convention in
\`strategies::NetGreeks\` doc comment.`
        }
    }
} as const;

export const $Ranking = {
    type: 'string',
    enum: ['pnl_at_target', 'expected_pnl', 'credit_over_risk', 'pop', 'view_score']
} as const;

export const $RealizedVol = {
    type: 'object',
    required: ['rv_20d', 'rv_5d', 'estimate', 'vrp', 'vrp_ratio', 'trend', 'method', 'n_spots'],
    properties: {
        estimate: {
            type: 'number',
            format: 'double'
        },
        method: {
            '$ref': '#/components/schemas/RvMethod'
        },
        n_spots: {
            type: 'integer',
            description: `Count of spot price observations used to compute this realized-vol
estimate (\`spot_history.len()\`), NOT a return-window length in days.
Number of usable log-returns derivable from this is \`n_spots - 1\`.`,
            minimum: 0
        },
        rv_20d: {
            type: 'number',
            format: 'double'
        },
        rv_5d: {
            type: 'number',
            format: 'double'
        },
        trend: {
            '$ref': '#/components/schemas/Trend'
        },
        vrp: {
            type: 'number',
            format: 'double'
        },
        vrp_ratio: {
            type: 'number',
            format: 'double'
        },
        vrp_regime: {
            '$ref': '#/components/schemas/VRPRegime'
        }
    }
} as const;

export const $RegimeResult = {
    type: 'object',
    description: 'Result of regime detection.',
    required: ['regime', 'confidence', 'spot_atm_corr', 'spot_skew_corr', 'iv_level', 'term_structure', 'event_flag'],
    properties: {
        confidence: {
            type: 'number',
            format: 'double'
        },
        event_flag: {
            type: 'boolean'
        },
        iv_level: {
            '$ref': '#/components/schemas/IVLevel'
        },
        regime: {
            '$ref': '#/components/schemas/VolatilityRegime'
        },
        spot_atm_corr: {
            type: 'number',
            format: 'double'
        },
        spot_skew_corr: {
            type: 'number',
            format: 'double'
        },
        term_structure: {
            '$ref': '#/components/schemas/TermStructure'
        }
    }
} as const;

export const $ResidualPoint = {
    type: 'object',
    description: 'A single monitoring point on the residual surface.',
    required: ['label', 'dte', 'residual', 'signal'],
    properties: {
        dte: {
            type: 'integer',
            format: 'int32'
        },
        label: {
            type: 'string'
        },
        residual: {
            type: 'number',
            format: 'double'
        },
        signal: {
            '$ref': '#/components/schemas/ResidualSignal'
        }
    }
} as const;

export const $ResidualSignal = {
    type: 'string',
    description: 'Signal for a single monitoring point.',
    enum: ['rich', 'cheap', 'fair']
} as const;

export const $ResolvedRequest = {
    type: 'object',
    properties: {
        absolute_strikes: {
            type: ['array', 'null'],
            items: {
                type: 'number',
                format: 'double'
            }
        },
        across_earnings: {
            type: ['boolean', 'null']
        },
        across_ex_date: {
            type: ['boolean', 'null']
        },
        anchor_band_pct: {
            type: ['number', 'null'],
            format: 'double'
        },
        anchor_strike: {
            type: ['number', 'null'],
            format: 'double'
        },
        back_dte: {
            type: ['integer', 'null'],
            format: 'int32'
        },
        breakeven_max: {
            type: ['number', 'null'],
            format: 'double'
        },
        breakeven_min: {
            type: ['number', 'null'],
            format: 'double'
        },
        by_delta_body: {
            type: ['number', 'null'],
            format: 'double'
        },
        by_delta_short: {
            type: ['number', 'null'],
            format: 'double'
        },
        by_delta_wings: {
            type: ['number', 'null'],
            format: 'double'
        },
        by_moneyness_pct: {
            type: ['number', 'null'],
            format: 'double'
        },
        cost_sign: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/CostSign'
                }
            ]
        },
        defined_risk_only: {
            type: 'boolean'
        },
        dte_max: {
            type: ['integer', 'null'],
            format: 'int32'
        },
        dte_min: {
            type: ['integer', 'null'],
            format: 'int32'
        },
        earnings_dates: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        expiry: {
            type: ['string', 'null']
        },
        families: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SearchFamily'
            }
        },
        far_wing_max: {
            type: ['number', 'null'],
            format: 'double'
        },
        far_wing_min: {
            type: ['number', 'null'],
            format: 'double'
        },
        front_dte: {
            type: ['integer', 'null'],
            format: 'int32'
        },
        greeks_delta_range: {
            type: ['array', 'null'],
            items: false,
            prefixItems: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    type: 'number',
                    format: 'double'
                }
            ]
        },
        greeks_gamma_sign: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ThetaBound'
                }
            ]
        },
        greeks_rho_sign: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ThetaBound'
                }
            ]
        },
        greeks_theta_sign: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ThetaBound'
                }
            ]
        },
        greeks_vega_sign: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ThetaBound'
                }
            ]
        },
        include_suspect: {
            type: ['boolean', 'null']
        },
        max_debit: {
            type: ['number', 'null'],
            format: 'double'
        },
        max_results: {
            type: ['integer', 'null'],
            minimum: 0
        },
        max_risk_dollars: {
            type: ['number', 'null'],
            format: 'double'
        },
        max_wing_steps: {
            type: ['integer', 'null'],
            minimum: 0
        },
        min_credit: {
            type: ['number', 'null'],
            format: 'double'
        },
        min_pop: {
            type: ['number', 'null'],
            format: 'double'
        },
        min_reward_to_risk: {
            type: ['number', 'null'],
            format: 'double'
        },
        month: {
            type: ['string', 'null']
        },
        near_wing_max: {
            type: ['number', 'null'],
            format: 'double'
        },
        near_wing_min: {
            type: ['number', 'null'],
            format: 'double'
        },
        owns_shares: {
            type: ['integer', 'null'],
            format: 'int32',
            minimum: 0
        },
        profile_axis: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/GreekAxis'
                }
            ]
        },
        profile_widen_families: {
            type: ['array', 'null'],
            items: {
                '$ref': '#/components/schemas/SearchFamily'
            }
        },
        quantity: {
            type: 'integer',
            format: 'int32'
        },
        ranking: {
            '$ref': '#/components/schemas/Ranking'
        },
        ratio: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/LegRatio'
                }
            ]
        },
        same_day: {
            type: 'boolean'
        },
        stock_direction: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/StockDirection'
                }
            ]
        },
        target_spot: {
            type: ['number', 'null'],
            format: 'double'
        },
        use_quotes: {
            type: ['boolean', 'null']
        },
        vol_direction: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/VolDirection'
                }
            ]
        },
        width_max: {
            type: ['number', 'null'],
            format: 'double'
        },
        width_min: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $RiskScore = {
    type: 'object',
    required: ['total', 'capital_risk'],
    properties: {
        capital_risk: {
            type: 'number',
            format: 'double'
        },
        prob_max_loss: {
            type: ['number', 'null'],
            format: 'double'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $RiskSpec = {
    type: 'object',
    properties: {
        budget_usd: {
            type: ['number', 'null'],
            format: 'double'
        },
        defined_risk_only: {
            type: ['boolean', 'null']
        },
        max_loss_usd: {
            type: ['number', 'null'],
            format: 'double'
        },
        quantity: {
            type: ['integer', 'null'],
            format: 'int32'
        }
    }
} as const;

export const $RuleCategory = {
    type: 'string',
    enum: ['Event', 'Regime', 'Vrp', 'Surface', 'VolCone', 'MeanRevert', 'Skew', 'Calendar', 'Directional', 'Protection', 'Risk']
} as const;

export const $RuleEffect = {
    oneOf: [
        {
            type: 'object',
            required: ['Caution'],
            properties: {
                Caution: {
                    type: 'string'
                }
            }
        },
        {
            type: 'object',
            required: ['Boost'],
            properties: {
                Boost: {
                    type: 'string'
                }
            }
        }
    ]
} as const;

export const $RuleFired = {
    type: 'object',
    required: ['id', 'name', 'priority', 'category', 'rationale'],
    properties: {
        category: {
            '$ref': '#/components/schemas/RuleCategory'
        },
        effect: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/RuleEffect'
                }
            ]
        },
        id: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        priority: {
            type: 'integer',
            format: 'int32',
            minimum: 0
        },
        rationale: {
            type: 'string'
        }
    }
} as const;

export const $RulesResult = {
    type: 'object',
    required: ['rules_fired', 'cautions', 'boosts', 'derived_metrics'],
    properties: {
        boosts: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/RuleFired'
            }
        },
        cautions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/RuleFired'
            }
        },
        derived_metrics: {
            '$ref': '#/components/schemas/DerivedMetrics'
        },
        rules_fired: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/RuleFired'
            }
        },
        vol_bias: {
            type: ['string', 'null']
        }
    }
} as const;

export const $RvMethod = {
    type: 'string',
    description: 'Method used to estimate realized volatility.',
    enum: ['close-to-close', 'garch', 'har', 'iv-proxy', 'parkinson', 'rogers-satchell', 'yang-zhang']
} as const;

export const $ScanBias = {
    type: 'string',
    description: 'Scan bias derived from regime + realized vol.',
    enum: ['neutral', 'favor_rich', 'favor_cheap']
} as const;

export const $ScanResult = {
    type: 'object',
    description: 'Scan result containing all mispriced options and statistics.',
    required: ['rich', 'cheap', 'residual_std', 'zscore_threshold', 'total_scanned', 'bias', 'r_squared', 'avg_model_error'],
    properties: {
        avg_model_error: {
            type: 'number',
            format: 'double'
        },
        bias: {
            '$ref': '#/components/schemas/ScanBias'
        },
        cheap: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MispricedPoint'
            }
        },
        r_squared: {
            type: 'number',
            format: 'double'
        },
        residual_std: {
            type: 'number',
            format: 'double'
        },
        rich: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MispricedPoint'
            }
        },
        total_scanned: {
            type: 'integer',
            minimum: 0
        },
        zscore_threshold: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $ScenarioContractPrice = {
    type: 'object',
    description: 'Contract priced under a user-specified scenario.',
    required: ['symbol', 'snapshot', 'strike', 'expiration', 'dte', 'market_call', 'market_put', 'scenario_call', 'scenario_put', 'call_diff', 'put_diff', 'scenario_iv', 'scenario_moneyness'],
    properties: {
        call_diff: {
            type: 'number',
            format: 'double',
            description: 'Call difference (scenario - market).'
        },
        dte: {
            type: 'integer',
            format: 'int32',
            description: `Remaining days-to-expiration under the scenario horizon
(= original \`expiration_days\` - \`scenario_days\`).`
        },
        expiration: {
            type: 'string'
        },
        market_call: {
            type: 'number',
            format: 'double',
            description: 'Original market call price.'
        },
        market_put: {
            type: 'number',
            format: 'double',
            description: 'Original market put price.'
        },
        put_diff: {
            type: 'number',
            format: 'double',
            description: 'Put difference (scenario - market).'
        },
        scenario_call: {
            type: 'number',
            format: 'double',
            description: 'Call price under scenario.'
        },
        scenario_iv: {
            type: 'number',
            format: 'double',
            description: 'IV interpolated from projected surface.'
        },
        scenario_moneyness: {
            type: 'number',
            format: 'double',
            description: 'Log-moneyness relative to scenario spot.'
        },
        scenario_put: {
            type: 'number',
            format: 'double',
            description: 'Put price under scenario.'
        },
        snapshot: {
            type: 'string',
            description: 'Snapshot / as-of trade date of the priced chain.'
        },
        strike: {
            type: 'number',
            format: 'double'
        },
        symbol: {
            type: 'string',
            description: 'Ticker symbol this contract belongs to.'
        }
    }
} as const;

export const $ScenarioForecast = {
    type: 'object',
    required: ['scenarios', 'iv_range_low', 'iv_range_high', 'directional_bias', 'key_insight'],
    properties: {
        directional_bias: {
            '$ref': '#/components/schemas/DirectionalBias'
        },
        iv_range_high: {
            type: 'number',
            format: 'double'
        },
        iv_range_low: {
            type: 'number',
            format: 'double'
        },
        key_insight: {
            type: 'string'
        },
        scenarios: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SpotScenario'
            }
        },
        spot_vol_beta_confidence: {
            type: 'number',
            format: 'double',
            description: 'Confidence score of spot-vol beta prediction (0.0-1.0).'
        },
        spot_vol_beta_source: {
            '$ref': '#/components/schemas/SpotVolBetaSource',
            description: 'Source of spot-vol beta prediction for auditability.'
        }
    }
} as const;

export const $ScenarioPricingSummary = {
    type: 'object',
    required: ['scenario_spot', 'scenario_days', 'snapshot', 'symbols', 'top_contracts', 'total_contracts'],
    properties: {
        scenario_days: {
            type: 'integer',
            format: 'int32',
            description: 'Days ahead for the scenario (horizon).'
        },
        scenario_spot: {
            type: 'number',
            format: 'double',
            description: 'Override spot price for the scenario.'
        },
        snapshot: {
            type: 'string',
            description: 'Snapshot / as-of trade date of the priced chain.'
        },
        symbols: {
            type: 'array',
            items: {
                type: 'string'
            },
            description: `Distinct symbols included in this pricing run (sorted, deduped).
Per-contract \`symbol\` is authoritative when more than one symbol is present.`
        },
        top_contracts: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ScenarioContractPrice'
            },
            description: 'Top contracts sorted by |call_diff| descending.'
        },
        total_contracts: {
            type: 'integer',
            description: 'Total number of contracts priced (before truncation).',
            minimum: 0
        }
    }
} as const;

export const $ScenarioWeights = {
    type: 'object',
    description: `SE-13: one shared set of scenario-weight policy assumptions, applied
IDENTICALLY to every candidate strategy under a given \`View\` -- never
sourced from any one strategy's own \`pop_view\`. These are declared
policy weights, NOT empirically calibrated market probabilities; see
\`DEFAULT_SCENARIO_WEIGHTS\` for the current default policy and
\`calculate_view_weighted_pnl\` for how they combine with a strategy's own
five scenario P&Ls (\`ViewPnl\`) into a genuine linear expectation.`,
    required: ['target', 'band_low', 'band_high', 'adverse_unchanged', 'adverse_reverse'],
    properties: {
        adverse_reverse: {
            type: 'number',
            format: 'double',
            description: 'Weight on the adverse-reversed-move scenario (`ViewPnl::adverse_reverse_pnl`).'
        },
        adverse_unchanged: {
            type: 'number',
            format: 'double',
            description: 'Weight on the adverse-unchanged-spot scenario (`ViewPnl::adverse_unchanged_pnl`).'
        },
        band_high: {
            type: 'number',
            format: 'double',
            description: 'Weight on the upper band-edge scenario (`ViewPnl::view_pnl_band_high`).'
        },
        band_low: {
            type: 'number',
            format: 'double',
            description: 'Weight on the lower band-edge scenario (`ViewPnl::view_pnl_band_low`).'
        },
        target: {
            type: 'number',
            format: 'double',
            description: 'Weight on the exact-target scenario (`ViewPnl::view_pnl`).'
        }
    }
} as const;

export const $ScoredStrategy = {
    type: 'object',
    required: ['name', 'category', 'score', 'description'],
    properties: {
        category: {
            '$ref': '#/components/schemas/StrategyCategory'
        },
        description: {
            type: 'string'
        },
        leverage_score: {
            type: 'number',
            format: 'double'
        },
        name: {
            '$ref': '#/components/schemas/StrategyName'
        },
        score: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $SearchCandidate = {
    type: 'object',
    required: ['family', 'label', 'expiry', 'dte', 'legs', 'net_credit', 'net_debit', 'cost_basis', 'net_credit_model', 'arbitrage_suspect', 'max_risk_unbounded', 'max_profit_unbounded', 'breakevens', 'net_greeks', 'score', 'score_kind', 'quantity', 'widths'],
    properties: {
        arbitrage_suspect: {
            type: 'boolean'
        },
        breakevens: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        },
        carry: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/CarryCost',
                    description: 'Debit structures only. Filled by `annotate_candidates`.'
                }
            ]
        },
        cost_basis: {
            '$ref': '#/components/schemas/CostBasis'
        },
        dte: {
            type: 'integer',
            format: 'int32'
        },
        expected_pnl_dollars: {
            type: ['number', 'null'],
            format: 'double'
        },
        expected_return: {
            type: ['number', 'null'],
            format: 'double',
            description: `Same as \`Strategy::expected_return\`: \`pop\`-weighted max profit/max risk
per share without a view, the view-weighted dollar P&L with one. \`None\`
without a view when either side is unbounded.`
        },
        expiry: {
            type: 'string'
        },
        family: {
            '$ref': '#/components/schemas/SearchFamily'
        },
        family_label: {
            type: 'string'
        },
        final_score: {
            type: 'number',
            format: 'double',
            description: 'Same as `Strategy::final_score` for a strategy outside the catalog.'
        },
        label: {
            type: 'string'
        },
        legs: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/StructureLeg'
            }
        },
        max_profit: {
            type: ['number', 'null'],
            format: 'double'
        },
        max_profit_dollars: {
            type: ['number', 'null'],
            format: 'double'
        },
        max_profit_unbounded: {
            type: 'boolean'
        },
        max_risk: {
            type: ['number', 'null'],
            format: 'double'
        },
        max_risk_dollars: {
            type: ['number', 'null'],
            format: 'double'
        },
        max_risk_unbounded: {
            type: 'boolean'
        },
        net_credit: {
            type: 'number',
            format: 'double'
        },
        net_credit_executable: {
            type: ['number', 'null'],
            format: 'double'
        },
        net_credit_model: {
            type: 'number',
            format: 'double'
        },
        net_debit: {
            type: 'number',
            format: 'double'
        },
        net_greeks: {
            '$ref': '#/components/schemas/NetGreeks'
        },
        oi_annotation: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/OaAnnotation',
                    description: 'Filled by `annotate_candidates` when synthetic OI is available.'
                }
            ]
        },
        pnl_at_target_dollars: {
            type: ['number', 'null'],
            format: 'double'
        },
        pop: {
            type: ['number', 'null'],
            format: 'double'
        },
        quantity: {
            type: 'integer',
            format: 'int32'
        },
        rationale: {
            type: 'string'
        },
        risk_score: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/RiskScore'
                }
            ]
        },
        score: {
            type: 'number',
            format: 'double'
        },
        score_kind: {
            '$ref': '#/components/schemas/Ranking'
        },
        theta_income: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ThetaIncome',
                    description: 'Credit structures only. Filled by `annotate_candidates`.'
                }
            ]
        },
        view_pnl_dollars: {
            type: ['number', 'null'],
            format: 'double'
        },
        widths: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        }
    }
} as const;

export const $SearchFamily = {
    type: 'string',
    enum: ['call_fly', 'put_fly', 'broken_wing_call_fly', 'broken_wing_put_fly', 'iron_fly', 'call_ratio1x2', 'put_ratio1x2', 'call_ratio1x3x2', 'put_ratio1x3x2', 'straddle', 'strangle', 'call_vertical', 'put_vertical', 'calendar_call', 'calendar_put', 'iron_condor', 'jade_lizard', 'risk_reversal', 'combo', 'single', 'covered_call', 'covered_put', 'collar', 'married_put', 'diagonal_call', 'diagonal_put']
} as const;

export const $SearchedExpiry = {
    type: 'object',
    required: ['date', 'dte', 'fwd', 'atm_iv', 'strikes'],
    properties: {
        atm_iv: {
            type: 'number',
            format: 'double'
        },
        date: {
            type: 'string'
        },
        dte: {
            type: 'integer',
            format: 'int32'
        },
        fwd: {
            type: 'number',
            format: 'double'
        },
        strikes: {
            type: 'integer',
            minimum: 0
        }
    }
} as const;

export const $ServerStatus = {
    type: 'object',
    required: ['repo_git_hash'],
    properties: {
        able_to_decode_jwt: {
            type: ['boolean', 'null']
        },
        cluster_pool_status: {
            type: ['string', 'null']
        },
        crunchy_db_status: {
            type: ['string', 'null']
        },
        hiro_db_status: {
            type: ['string', 'null']
        },
        hostname: {
            type: ['string', 'null']
        },
        openai_api_status: {
            type: ['string', 'null']
        },
        repo_git_hash: {
            type: 'string'
        },
        s3_status: {
            type: ['string', 'null']
        },
        scylla_db_status: {
            type: ['string', 'null']
        },
        users_db_status: {
            type: ['string', 'null']
        }
    }
} as const;

export const $ServiceTier = {
    type: 'string',
    description: 'Specifies the processing type used for serving the request.',
    enum: ['auto', 'default', 'flex', 'scale', 'priority']
} as const;

export const $SettlementStyleResponse = {
    type: 'object',
    required: ['symbol'],
    properties: {
        styles: {
            type: ['object', 'null'],
            additionalProperties: {
                '$ref': '#/components/schemas/IpfExerciseStyle'
            },
            propertyNames: {
                type: 'string'
            }
        },
        symbol: {
            type: 'string'
        },
        uniform_style: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/IpfExerciseStyle'
                }
            ]
        }
    }
} as const;

export const $SetupProfileLabel = {
    type: 'string',
    description: `Which of the four Setup Profiles picks a row is, on \`opening_setup_profiles\`. Mirrors the
\`label\` strings \`_build_compact_trade_ideas\` in flow_patrol/opening_print_sections.py writes
(also used there as the PDF card's visible header text), so the two must be changed together.`,
    enum: ['BULL', 'BEAR', 'SHORT VOL', 'LONG VOL']
} as const;

export const $SetupProfilesRsp = {
    type: 'object',
    required: ['report_date', 'profiles'],
    properties: {
        profiles: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/OpeningSetupProfile'
            }
        },
        report_date: {
            type: 'string',
            format: 'date'
        }
    }
} as const;

export const $Side = {
    type: 'string',
    enum: ['buy', 'sell']
} as const;

export const $SkewBacktestRow = {
    type: 'object',
    description: 'A single row in the skew backtest results.',
    required: ['as_of_date', 'future_date', 'hold_days', 'current_skew_25d', 'projected_skew_25d', 'realized_skew_25d', 'skew_error', 'abs_skew_error', 'unchanged_skew_error', 'abs_unchanged_skew_error', 'skew_model_beats_unchanged'],
    properties: {
        abs_skew_error: {
            type: 'number',
            format: 'double',
            description: '|projected - realized|'
        },
        abs_unchanged_skew_error: {
            type: 'number',
            format: 'double',
            description: '|current - realized| (unchanged baseline absolute error)'
        },
        as_of_date: {
            type: 'string'
        },
        current_skew_25d: {
            type: 'number',
            format: 'double',
            description: '25-delta skew observed on the as-of date (put IV - call IV).'
        },
        future_date: {
            type: 'string'
        },
        hold_days: {
            type: 'integer',
            format: 'int32'
        },
        projected_skew_25d: {
            type: 'number',
            format: 'double',
            description: 'What the model thinks 25-delta skew will be at forecast horizon.'
        },
        realized_skew_25d: {
            type: 'number',
            format: 'double',
            description: 'The actual 25-delta skew observed on the future target date.'
        },
        skew_error: {
            type: 'number',
            format: 'double',
            description: 'projected - realized'
        },
        skew_model_beats_unchanged: {
            type: 'boolean',
            description: 'Whether projected skew was closer to realized than unchanged baseline.'
        },
        unchanged_skew_error: {
            type: 'number',
            format: 'double',
            description: 'current - realized (unchanged baseline error)'
        }
    }
} as const;

export const $SkewBacktestSummary = {
    type: 'object',
    description: 'Aggregate statistics for the skew backtest.',
    required: ['rows', 'projected_mae', 'unchanged_mae', 'model_beat_count', 'model_lose_count', 'total_rows'],
    properties: {
        model_beat_count: {
            type: 'integer',
            minimum: 0
        },
        model_lose_count: {
            type: 'integer',
            minimum: 0
        },
        projected_mae: {
            type: 'number',
            format: 'double'
        },
        rows: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SkewBacktestRow'
            }
        },
        total_rows: {
            type: 'integer',
            minimum: 0
        },
        unchanged_mae: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $SkewBeta = {
    type: 'object',
    description: `Calibrated regression of daily 25-delta skew change on spot return, for a
single symbol and tenor. Structurally parallel to \`SpotVolBeta\` but
targets skew instead of ATM IV level, and has no asymmetric up/down or
market-proxy terms (single-predictor OLS: skew responds primarily to
direction of spot move via the delta-skew relationship, not magnitude
splits).`,
    required: ['symbol', 'tenor_days', 'beta', 'intercept', 'r_squared', 'sample_size'],
    properties: {
        beta: {
            type: 'number',
            format: 'double'
        },
        intercept: {
            type: 'number',
            format: 'double'
        },
        r_squared: {
            type: 'number',
            format: 'double'
        },
        sample_size: {
            type: 'integer',
            minimum: 0
        },
        symbol: {
            type: 'string'
        },
        tenor_days: {
            type: 'integer',
            format: 'int32'
        }
    }
} as const;

export const $SkewPlotData = {
    type: 'object',
    description: 'Skew plot data for frontend visualization.',
    required: ['expiration', 'dte', 'strikes', 'ivs', 'spot'],
    properties: {
        dte: {
            type: 'integer',
            format: 'int32'
        },
        expiration: {
            type: 'string'
        },
        ivs: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        },
        spot: {
            type: 'number',
            format: 'double'
        },
        strikes: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        }
    }
} as const;

export const $SkewPlotResponse = {
    type: 'object',
    description: 'Skew plot response with forward vol data.',
    required: ['expirations'],
    properties: {
        expirations: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SkewPlotData'
            }
        },
        forward_vol_data: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ForwardVolData'
                }
            ]
        }
    }
} as const;

export const $SkewTier = {
    type: 'string',
    description: `Skew tier (put-skew richness). \`skew_25d\` is positive-typical (put_iv - call_iv,
see \`iv_surface::compute_skew_25d\`); Steep = more positive than baseline (puts
rich), Flat = less positive / negative than baseline (puts cheap).`,
    enum: ['Steep', 'Neutral', 'Flat']
} as const;

export const $SlopeBacktestRow = {
    type: 'object',
    description: 'Slope between two tenors: IV(longer) - IV(shorter).',
    required: ['as_of_date', 'future_date', 'hold_days', 'short_tenor', 'long_tenor', 'current_slope', 'projected_slope', 'realized_slope', 'error', 'unchanged_error', 'beats_unchanged'],
    properties: {
        as_of_date: {
            type: 'string'
        },
        beats_unchanged: {
            type: 'boolean',
            description: 'Whether projected was closer to realized than unchanged.'
        },
        current_slope: {
            type: 'number',
            format: 'double',
            description: 'Slope = IV(longer) - IV(shorter) at as-of date.'
        },
        error: {
            type: 'number',
            format: 'double',
            description: 'projected - realized'
        },
        future_date: {
            type: 'string'
        },
        hold_days: {
            type: 'integer',
            format: 'int32'
        },
        long_tenor: {
            type: 'integer',
            format: 'int32'
        },
        projected_slope: {
            type: 'number',
            format: 'double',
            description: 'Slope in projected surface.'
        },
        realized_slope: {
            type: 'number',
            format: 'double',
            description: 'Slope observed on future date.'
        },
        short_tenor: {
            type: 'integer',
            format: 'int32'
        },
        unchanged_error: {
            type: 'number',
            format: 'double',
            description: 'current - realized (unchanged baseline)'
        }
    }
} as const;

export const $SlopePairSummary = {
    type: 'object',
    description: 'Aggregate statistics for one slope pair.',
    required: ['short_tenor', 'long_tenor', 'rows', 'projected_mae', 'unchanged_mae', 'model_beat_count', 'total_rows'],
    properties: {
        long_tenor: {
            type: 'integer',
            format: 'int32'
        },
        model_beat_count: {
            type: 'integer',
            minimum: 0
        },
        projected_mae: {
            type: 'number',
            format: 'double'
        },
        rows: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SlopeBacktestRow'
            }
        },
        short_tenor: {
            type: 'integer',
            format: 'int32'
        },
        total_rows: {
            type: 'integer',
            minimum: 0
        },
        unchanged_mae: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $SlopeTier = {
    type: 'string',
    description: 'Term-structure slope tier (90d ATM IV minus 7d ATM IV).',
    enum: ['Inverted', 'Mid', 'Contango', 'Unknown']
} as const;

export const $SpotScenario = {
    type: 'object',
    required: ['name', 'spot_change', 'final_atm_iv', 'regime_likely', 'notes', 'iv_path'],
    properties: {
        final_atm_iv: {
            type: 'number',
            format: 'double'
        },
        iv_path: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        },
        name: {
            type: 'string'
        },
        notes: {
            type: 'string'
        },
        regime_likely: {
            type: 'string'
        },
        spot_change: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $SpotVolBeta = {
    type: 'object',
    description: `Calibrated spot-vol beta model for ATM IV changes.

This represents the minimum production contract for replacing fixed
Bennett-style correlations with calibrated, tenor-aware spot-vol response:

\`\`\`text
Δσ_ATM,T = α + β*r + β_down*min(r, 0) + β_up*max(r, 0) + γ*Δσ_market,T
\`\`\`

The calibration target is daily ATM IV point change for a given tenor. See:
- Aït-Sahalia, Fan, Li: https://www.nber.org/papers/w17592
- Chong, Todorov: https://arxiv.org/abs/2305.04137
- Ciliberti, Bouchaud, Potters: https://arxiv.org/abs/0809.3375`,
    required: ['symbol', 'tenor_days', 'beta', 'beta_up', 'beta_down', 'market_vol_beta', 'intercept', 'r_squared', 'sample_size', 'lookback_days', 'residual_rmse', 'confidence', 'source'],
    properties: {
        beta: {
            type: 'number',
            format: 'double'
        },
        beta_down: {
            type: 'number',
            format: 'double'
        },
        beta_up: {
            type: 'number',
            format: 'double'
        },
        confidence: {
            type: 'number',
            format: 'double'
        },
        intercept: {
            type: 'number',
            format: 'double'
        },
        lookback_days: {
            type: 'integer',
            minimum: 0
        },
        market_vol_beta: {
            type: 'number',
            format: 'double'
        },
        r_squared: {
            type: 'number',
            format: 'double'
        },
        residual_rmse: {
            type: 'number',
            format: 'double'
        },
        sample_size: {
            type: 'integer',
            minimum: 0
        },
        source: {
            '$ref': '#/components/schemas/SpotVolBetaSource'
        },
        symbol: {
            type: 'string'
        },
        tenor_days: {
            type: 'integer',
            format: 'int32'
        }
    }
} as const;

export const $SpotVolBetaSource = {
    type: 'string',
    description: 'Source used for a spot-vol beta prediction.',
    enum: ['SymbolTenor', 'SymbolPooled', 'SectorTenor', 'MarketTenor', 'BennettFallback', 'AttenuatedFromAnchor']
} as const;

export const $SpotVolRegime = {
    type: 'string',
    description: `Spot-vol correlation coefficient by volatility regime.

Different regimes exhibit different spot-vol correlations:
- StickyStrike: Strong negative correlation (spot up → vol down)
- StickyDeltaMoneyness: Moderate negative correlation
- StickyImpliedTree: Weak negative correlation
- ReverseSkew: Positive correlation (spot up → vol up)`,
    enum: ['StickyStrike', 'StickyDeltaMoneyness', 'StickyImpliedTree', 'ReverseSkew']
} as const;

export const $SpotVolSurfaceBeta = {
    type: 'object',
    description: `Full-surface spot-vol beta model for one symbol: per-tenor ATM betas plus
per-tenor skew betas. Always contains an entry in \`tenor_betas\` for every
tenor in \`spot_vol_calibration::TENOR_BUCKETS\` (directly calibrated or
attenuated from the anchor); \`skew_betas\` may have missing entries for
tenors where skew calibration had insufficient samples.`,
    required: ['symbol', 'tenor_betas', 'skew_betas'],
    properties: {
        skew_betas: {
            type: 'object',
            additionalProperties: {
                '$ref': '#/components/schemas/SkewBeta'
            },
            propertyNames: {
                type: 'integer',
                format: 'int32'
            }
        },
        symbol: {
            type: 'string'
        },
        tenor_betas: {
            type: 'object',
            additionalProperties: {
                '$ref': '#/components/schemas/SpotVolBeta'
            },
            propertyNames: {
                type: 'integer',
                format: 'int32'
            }
        }
    }
} as const;

export const $Spread = {
    type: 'object',
    description: 'Spread for surface edge analysis.',
    required: ['spread_type', 'long', 'short', 'is_credit', 'net_bid', 'net_ask', 'net_mid', 'net_edge', 'edge_pct', 'max_profit', 'max_loss', 'strike_width', 'impl_prob_midpoint'],
    properties: {
        edge_pct: {
            type: 'number',
            format: 'double'
        },
        impl_prob_midpoint: {
            type: 'number',
            format: 'double'
        },
        is_credit: {
            type: 'boolean'
        },
        long: {
            '$ref': '#/components/schemas/OptionLeg'
        },
        max_loss: {
            type: 'number',
            format: 'double'
        },
        max_profit: {
            type: 'number',
            format: 'double'
        },
        net_ask: {
            type: 'number',
            format: 'double'
        },
        net_bid: {
            type: 'number',
            format: 'double'
        },
        net_edge: {
            type: 'number',
            format: 'double'
        },
        net_mid: {
            type: 'number',
            format: 'double'
        },
        short: {
            '$ref': '#/components/schemas/OptionLeg'
        },
        spread_type: {
            '$ref': '#/components/schemas/SpreadType'
        },
        strike_width: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $SpreadType = {
    type: 'string',
    description: 'Spread type for surface edge.',
    enum: ['BearPut', 'BullCall', 'BearCall', 'BullPut']
} as const;

export const $StanceConditioning = {
    type: 'object',
    description: 'Aggregated conditioning verdict for one analysis snapshot.',
    required: ['event_window_zone', 'corr_bucket', 'slope_tier', 'skew_tier', 'skew_verdict', 'short_vega_blocked_by_event', 'short_vega_blocked_by_corr', 'block_reasons', 'dec_seasonal'],
    properties: {
        block_reasons: {
            type: 'array',
            items: {
                type: 'string'
            },
            description: 'Human-readable block reasons for the snapshot (empty when none).'
        },
        corr_bucket: {
            '$ref': '#/components/schemas/CorrRegimeBucket'
        },
        dec_seasonal: {
            '$ref': '#/components/schemas/DecSeasonal',
            description: `Whether this snapshot's trade_date falls in calendar December.
Informational only — not consumed by any gating logic yet.`
        },
        event_window_zone: {
            '$ref': '#/components/schemas/EventWindowZone'
        },
        short_vega_blocked_by_corr: {
            type: 'boolean',
            description: 'True when a short-vega rec was disallowed by low correlation this snapshot.'
        },
        short_vega_blocked_by_event: {
            type: 'boolean',
            description: 'True when a short-vega rec was disallowed by event geometry this snapshot.'
        },
        skew_tier: {
            '$ref': '#/components/schemas/SkewTier'
        },
        skew_verdict: {
            type: 'string',
            description: 'Rich/cheap text for the frontend harness, e.g. "Skew rich (steep)".'
        },
        slope_tier: {
            '$ref': '#/components/schemas/SlopeTier'
        }
    }
} as const;

export const $StandardizedSurface = {
    type: 'object',
    required: ['moneyness', 'tte', 'ivs'],
    properties: {
        ivs: {
            type: 'array',
            items: {
                type: 'array',
                items: {
                    type: 'number',
                    format: 'double'
                }
            }
        },
        moneyness: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        },
        tte: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        }
    }
} as const;

export const $StockDirection = {
    type: 'string',
    enum: ['bullish', 'bearish', 'neutral']
} as const;

export const $Strategy = {
    type: 'object',
    required: ['name', 'legs', 'net_credit', 'max_risk', 'net_greeks', 'rationale', 'dte', 'dividend_alerts'],
    properties: {
        carry: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/CarryCost'
                }
            ]
        },
        category: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/StrategyCategory',
                    description: `SE-11: this instance's realized category (credit or debit). \`None\`
for any \`Strategy\` built by a path that predates this field (e.g. a
deserialized legacy JSON payload) -- never inferred after the fact.`
                }
            ]
        },
        conditioning_note: {
            type: ['string', 'null'],
            description: `SE-05: set to \`Some("event tie-break applied")\` when the event-conditioning
tie-break reordered this candidate relative to a near-tied peer. Never set
as a side effect of score computation -- \`final_score\`/\`expected_return\`
are never written by conditioning; only this note and ordering may change.`
        },
        dividend_alerts: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DividendAlert'
            }
        },
        dte: {
            type: 'integer',
            format: 'int32',
            description: `Days to expiry driving this strategy's decay horizon (Item 6 / P1).
For single-expiry structures this is that expiry's DTE; for
multi-tenor structures (e.g. calendar spreads) this is the FRONT
(nearer) expiry's DTE, matching where \`carry\`/\`theta_income\` anchor
their "total to expiry" horizon. Used by the CLI display layer to
decide whether to show the DTE<=3 full-extrinsic framing line.`
        },
        expected_return: {
            type: 'number',
            format: 'double',
            description: `Expected P&L. View-free path (no \`View\` supplied): prob_win ×
max_profit - prob_loss × max_risk, unchanged by SE-13. View-
conditional path (a \`View\` was supplied and repricing succeeded,
i.e. whenever \`view_pnl\`/\`scenario_weights\` are \`Some\`): SE-13
shared-policy-weighted linear expectation over \`view_pnl\`'s five
scenario P&Ls (see \`risk::calculate_view_weighted_pnl\` and
\`scenario_weights\`) -- comparable and summable across every
candidate strategy scored under the same view, unlike the retired
per-strategy-POP-weighted \`heuristic_score\`.`
        },
        final_score: {
            type: 'number',
            format: 'double',
            description: 'Composite final score (risk-adjusted return × risk retention × catalog alignment).'
        },
        heuristic_score: {
            type: 'number',
            format: 'double',
            description: `SE-13: the RETIRED trade-specific-POP-weighted blend of this
strategy's own five view scenarios (the value \`expected_return\`
held before the SE-13 fix). Preserved for continuity with prior
consumers; NOT a shared/comparable expectation across candidates --
unlike \`expected_return\`, this number is weighted by THIS strategy's
own \`pop_view\`, so it must never be summed or compared across
different candidate strategies. See \`expected_return\` for the
shared-policy-weighted number safe to compare/sum across candidates.`
        },
        legs: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Leg'
            }
        },
        max_profit: {
            type: 'number',
            format: 'double',
            description: 'Maximum profit potential.'
        },
        max_profit_unbounded: {
            type: 'boolean',
            description: `True when this strategy's real maximum profit is unbounded (long
call, long straddle, long strangle). When true, \`max_profit\` is NOT
the true maximum: for \`LongCall\` it's an internal-arithmetic
placeholder with no display meaning; for \`LongStraddle\`/\`LongStrangle\`
it's the real, finite DOWNSIDE-bound maximum (spot -> 0), not the
(infinite) true max. Populated once, post-construction, in
\`analysis::mod\`'s finalize loop via \`StrategyRef::is_profit_unbounded()\`.
Display/JSON consumers MUST check this flag before presenting
\`max_profit\` as "the" maximum profit.`
        },
        max_risk: {
            type: 'number',
            format: 'double'
        },
        max_risk_kind: {
            '$ref': '#/components/schemas/MaxRiskKind',
            description: `AUD26-SE09: classifies whether \`max_risk\` is a true payoff bound
(\`Bound\`, the default/legacy meaning for every strategy) or a
VIEW-01 stress estimate (\`Stress\` -- currently only the six
calendar/diagonal names, and only when \`view_pnl\` is \`Some\`).
Consumers (CLI/JSON) MUST check this before presenting \`max_risk\` as
"Max Risk".`
        },
        max_risk_unbounded: {
            type: 'boolean'
        },
        name: {
            '$ref': '#/components/schemas/StrategyName'
        },
        net_credit: {
            type: 'number',
            format: 'double'
        },
        net_debit: {
            type: 'number',
            format: 'double',
            description: `Net debit paid (positive for debit spreads, 0 for credit spreads).
Computed as max(0, -net_credit).`
        },
        net_greeks: {
            '$ref': '#/components/schemas/NetGreeks'
        },
        oi_annotation: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/OaAnnotation',
                    description: 'Placeholder for OI annotation (disabled).'
                }
            ]
        },
        pop: {
            type: ['number', 'null'],
            format: 'double'
        },
        pop_unavailable_reason: {
            type: ['string', 'null'],
            description: `Human-readable reason \`pop\` is \`None\`. Always \`Some\` exactly when
\`pop\` is \`None\`; always \`None\` exactly when \`pop\` is \`Some\`. NEVER
coerce \`pop\` to a number when this is \`Some\` -- serialize/display
both fields together (see \`sg-risk-engine-cli\`'s server.rs and
display.rs).`
        },
        rationale: {
            type: 'string'
        },
        risk_adjusted_return: {
            type: 'number',
            format: 'double',
            description: 'Risk-adjusted return (expected_return / margin).'
        },
        risk_score: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/RiskScore',
                    description: 'Multi-factor risk score breakdown.'
                }
            ]
        },
        scenario_weights: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ScenarioWeights',
                    description: `SE-13: the shared, declared policy scenario weights used to compute
\`expected_return\` from \`view_pnl\`'s five scenario P&Ls. Present
exactly when \`view_pnl\` is present, and identical across every
candidate strategy in a given analysis run -- this is a declared
policy assumption, NOT an empirically calibrated market probability
distribution.`
                }
            ]
        },
        stress_max_loss: {
            type: ['number', 'null'],
            format: 'double',
            description: `AUD26-SE09: the VIEW-01 stress estimate itself, in the same units
and sign convention as \`max_risk\` (positive = a dollar loss is
possible). \`Some\` exactly when \`max_risk_kind == MaxRiskKind::Stress\`;
\`None\` otherwise (including every non-calendar/diagonal strategy and
the no-view path). When \`Some\`, this value equals \`max_risk\` -- the
field exists so JSON consumers have an explicit, unambiguously-named
key rather than having to branch on \`max_risk_kind\` to know how to
read \`max_risk\`.`
        },
        theta_income: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ThetaIncome'
                }
            ]
        },
        view_pnl: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ViewPnl',
                    description: `VIEW-01: P&L under the user's view (target/band/adverse scenarios),
computed by repricing every leg at the view's target/horizon on the
projected surface. Present only when a \`View\` was supplied and
repricing succeeded for this candidate; absent for the no-view
analytics-only path (which never carries a ranked strategy list) and
for the scanner-origin path, which is out of scope for VIEW-01.`
                }
            ]
        },
        vrp_conflict_note: {
            type: ['string', 'null'],
            description: `Conflict note surfaced when this strategy's net vega sign opposes the
model's own VRP verdict beyond +/-10%. Present only for a recommendation
whose vol direction contradicts the rich/cheap read. Absent otherwise.`
        }
    }
} as const;

export const $StrategyCategory = {
    type: 'string',
    enum: ['SingleLeg', 'Debit', 'Credit', 'Calendar', 'Income', 'Ratio', 'Synthetic', 'Special']
} as const;

export const $StrategyName = {
    type: 'string',
    description: 'Named strategy identifiers - replaces all stringly-typed strategy names.',
    enum: ['LongCall', 'ShortCall', 'LongPut', 'ShortPut', 'LongCallSpread', 'LongPutSpread', 'ShortCallSpread', 'ShortPutSpread', 'IronCondor', 'IronButterfly', 'LongCallFly', 'LongPutFly', 'BrokenWingButterfly', 'JadeLizard', 'LongStraddle', 'ShortStraddle', 'LongStrangle', 'ShortStrangle', 'LongCalendarCall', 'LongCalendarPut', 'ShortCalendarCall', 'ShortCalendarPut', 'DiagonalSpread', 'DiagonalPut', 'CoveredCall', 'CoveredPut', 'Collar', 'MarriedPut', 'CoveredStrangle', 'Combo', 'RiskReversal', 'SyntheticPut', 'SyntheticCall', 'LongCallRatioSpread', 'LongPutRatioSpread', 'ShortCallRatioSpread', 'ShortPutRatioSpread', 'DeltaOne']
} as const;

export const $StrikeSpec = {
    type: 'object',
    properties: {
        absolute: {
            type: ['array', 'null'],
            items: {
                type: 'number',
                format: 'double'
            }
        },
        by_delta: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/DeltaStrikes'
                }
            ]
        },
        by_moneyness_pct: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $StructureLeg = {
    type: 'object',
    required: ['strike', 'expiry', 'option_type', 'action', 'price', 'delta', 'gamma', 'theta', 'vega'],
    properties: {
        action: {
            '$ref': '#/components/schemas/Action'
        },
        delta: {
            type: 'number',
            format: 'double'
        },
        exercise_style: {
            '$ref': '#/components/schemas/ExerciseStyle'
        },
        expiry: {
            type: 'string'
        },
        gamma: {
            type: 'number',
            format: 'double'
        },
        iv: {
            type: 'number',
            format: 'double'
        },
        multiplier: {
            type: 'number',
            format: 'double'
        },
        option_type: {
            '$ref': '#/components/schemas/OptionType'
        },
        price: {
            type: 'number',
            format: 'double'
        },
        pricing_model: {
            '$ref': '#/components/schemas/PricingModel'
        },
        quantity: {
            type: 'integer',
            format: 'int32'
        },
        strike: {
            type: 'number',
            format: 'double'
        },
        style_provenance: {
            '$ref': '#/components/schemas/StyleProvenance'
        },
        theta: {
            type: 'number',
            format: 'double'
        },
        vega: {
            type: 'number',
            format: 'double'
        },
        yte: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $StructureRequest = {
    type: 'object',
    properties: {
        bounds: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/BoundsSpec'
                }
            ]
        },
        context: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ContextSpec'
                }
            ]
        },
        cost: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/CostSpec'
                }
            ]
        },
        geometry: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/GeometrySpec'
                }
            ]
        },
        max_results: {
            type: ['integer', 'null'],
            format: 'int32',
            minimum: 0
        },
        ranking: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/Ranking'
                }
            ]
        },
        risk: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/RiskSpec'
                }
            ]
        },
        side: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/Side'
                }
            ]
        },
        strikes: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/StrikeSpec'
                }
            ]
        },
        structure: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/StructureSpec'
                }
            ]
        },
        symbol: {
            type: ['string', 'null']
        },
        tenor: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/TenorSpec'
                }
            ]
        },
        view: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ViewSpec'
                }
            ]
        }
    }
} as const;

export const $StructureSearchResult = {
    type: 'object',
    required: ['request', 'resolved', 'symbol', 'spot', 'expiries', 'considered', 'matched', 'candidates', 'notes'],
    properties: {
        candidates: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SearchCandidate'
            }
        },
        considered: {
            type: 'integer',
            minimum: 0
        },
        expiries: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SearchedExpiry'
            }
        },
        matched: {
            type: 'integer',
            minimum: 0
        },
        notes: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        request: {
            '$ref': '#/components/schemas/StructureRequest'
        },
        resolved: {
            '$ref': '#/components/schemas/ResolvedRequest'
        },
        spot: {
            type: 'number',
            format: 'double'
        },
        symbol: {
            type: 'string'
        }
    }
} as const;

export const $StructureSpec = {
    type: 'object',
    properties: {
        families: {
            type: ['array', 'null'],
            items: {
                '$ref': '#/components/schemas/SearchFamily'
            }
        },
        profile: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/GreekProfile'
                }
            ]
        }
    }
} as const;

export const $StyleProvenance = {
    type: 'string',
    description: `How an option row's \`ExerciseStyle\` classification was sourced.
Run-level (the style map loads once per process), stamped per-row so it
rides the same plumbing as \`ExerciseStyle\` into leg JSON and card text.`,
    enum: ['ipf', 'stale_cache', 'fallback']
} as const;

export const $SurfaceEdgeResult = {
    type: 'object',
    description: 'Surface edge result.',
    required: ['top_legs', 'top_spreads'],
    properties: {
        recommended: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/Spread'
                }
            ]
        },
        spot_vol_beta_confidence: {
            type: 'number',
            format: 'double',
            description: 'Confidence score of spot-vol beta prediction (0.0-1.0).'
        },
        spot_vol_beta_source: {
            '$ref': '#/components/schemas/SpotVolBetaSource',
            description: 'Source of spot-vol beta prediction for auditability.'
        },
        stale_warning: {
            type: ['string', 'null']
        },
        top_legs: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/OptionLeg'
            }
        },
        top_spreads: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Spread'
            }
        }
    }
} as const;

export const $SurfaceQuality = {
    type: 'object',
    required: ['butterfly_clean', 'calendar_clean', 'composite'],
    properties: {
        butterfly_clean: {
            type: 'boolean'
        },
        calendar_clean: {
            type: 'boolean'
        },
        composite: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $SurfaceResiduals = {
    type: 'object',
    description: 'Result of surface residual computation.',
    required: ['points', 'rmse', 'wing_skew_richness'],
    properties: {
        points: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ResidualPoint'
            }
        },
        rmse: {
            type: 'number',
            format: 'double'
        },
        wing_skew_richness: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $SviSurfaceSummary = {
    type: 'object',
    description: 'Summary of the SVI-fitted volatility surface for JSON output.',
    required: ['n_slices', 'arbitrage_quality', 'atm_term_structure', 'skew_25d', 'standardized_grid'],
    properties: {
        arbitrage_quality: {
            '$ref': '#/components/schemas/SurfaceQuality'
        },
        atm_term_structure: {
            type: 'array',
            items: {
                type: 'array',
                items: false,
                prefixItems: [
                    {
                        type: 'integer',
                        format: 'int32'
                    },
                    {
                        type: 'number',
                        format: 'double'
                    }
                ]
            }
        },
        fit_quality: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/FitQuality'
                }
            ]
        },
        n_slices: {
            type: 'integer',
            minimum: 0
        },
        skew_25d: {
            type: 'array',
            items: {
                type: 'array',
                items: false,
                prefixItems: [
                    {
                        type: 'integer',
                        format: 'int32'
                    },
                    {
                        type: 'number',
                        format: 'double'
                    }
                ]
            }
        },
        standardized_grid: {
            '$ref': '#/components/schemas/StandardizedSurface'
        }
    }
} as const;

export const $Sym = {
    type: 'string'
} as const;

export const $SymbolCandle = {
    type: 'object',
    required: ['sym', 'time', 'open', 'high', 'low', 'close'],
    properties: {
        close: {
            type: 'number',
            format: 'float'
        },
        high: {
            type: 'number',
            format: 'float'
        },
        low: {
            type: 'number',
            format: 'float'
        },
        open: {
            type: 'number',
            format: 'float'
        },
        sym: {
            type: 'string'
        },
        time: {
            type: 'string',
            format: 'date-time'
        },
        volume: {
            type: ['number', 'null'],
            format: 'float'
        }
    }
} as const;

export const $SyntheticOIInput = {
    type: 'object',
    description: 'Synthetic OI data passed from frontend (pre-loaded from DB).',
    required: ['quote_date', 'spot', 'customer', 'firm', 'market_maker', 'entity_direction', 'key_levels'],
    properties: {
        customer: {
            '$ref': '#/components/schemas/EntityVolPoints'
        },
        entity_direction: {
            '$ref': '#/components/schemas/EntityDirection'
        },
        firm: {
            '$ref': '#/components/schemas/EntityVolPoints'
        },
        iv_pct: {
            type: ['number', 'null'],
            format: 'double'
        },
        iv_rank: {
            type: ['number', 'null'],
            format: 'double'
        },
        key_levels: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/KeyLevel'
            }
        },
        market_maker: {
            '$ref': '#/components/schemas/EntityVolPoints'
        },
        quote_date: {
            type: 'string'
        },
        skew_rank: {
            type: ['number', 'null'],
            format: 'double'
        },
        spot: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $TVTPOutput = {
    type: 'object',
    description: 'TVTP detection output.',
    required: ['regime', 'regime_probabilities', 'confidence', 'transition_matrix'],
    properties: {
        confidence: {
            type: 'number',
            format: 'double'
        },
        data_quality_degraded: {
            type: 'boolean',
            description: `True when emission normalization degenerated (extreme/NaN inputs) and
the reported regime/confidence are not meaningful. Callers must treat a
degraded output as missing data, never as a confident Normal.`
        },
        regime: {
            '$ref': '#/components/schemas/TVTPRegime'
        },
        regime_probabilities: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        },
        transition_matrix: {
            type: 'array',
            items: {
                type: 'array',
                items: {
                    type: 'number',
                    format: 'double'
                }
            }
        }
    }
} as const;

export const $TVTPRegime = {
    type: 'string',
    description: 'TVTP regime classification.',
    enum: ['LowVol', 'Normal', 'HighVol', 'Crisis']
} as const;

export const $TenorSpec = {
    type: 'object',
    properties: {
        back_dte: {
            type: ['integer', 'null'],
            format: 'int32'
        },
        expiry: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ExpirySelector'
                }
            ]
        },
        front_dte: {
            type: ['integer', 'null'],
            format: 'int32'
        }
    }
} as const;

export const $TenorVRP = {
    type: 'object',
    description: 'VRP at a single tenor.',
    required: ['dte', 'iv', 'rv', 'ratio', 'level'],
    properties: {
        dte: {
            type: 'integer',
            format: 'int32'
        },
        ex_event_iv: {
            type: ['number', 'null'],
            format: 'double',
            description: `Diffusive ATM IV at this tenor after stripping the priced event variance
σ²_j/T. None when no event adjustment was applied.`
        },
        ex_event_level: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Ex-event VRP level (ex_event_iv - rv). None when no event adjustment.'
        },
        iv: {
            type: 'number',
            format: 'double'
        },
        iv_rank: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Percentile of current ATM IV vs rolling IV distribution. None if insufficient history.'
        },
        level: {
            type: 'number',
            format: 'double'
        },
        ratio: {
            type: 'number',
            format: 'double'
        },
        rv: {
            type: 'number',
            format: 'double'
        },
        vrp_rank: {
            type: ['number', 'null'],
            format: 'double',
            description: 'Percentile of current VRP vs rolling VRP distribution. None if insufficient history.'
        }
    }
} as const;

export const $TermSlope = {
    type: 'string',
    description: 'Term structure slope classification.',
    enum: ['backwardation', 'contango', 'flat']
} as const;

export const $TermStructure = {
    type: 'string',
    description: 'Term structure classification.',
    enum: ['contango', 'flat', 'backwardation', 'steepening', 'flattening']
} as const;

export const $TermStructureAnalysis = {
    type: 'object',
    description: 'Complete term structure analysis result.',
    required: ['forward_vols', 'base_vols', 'event_vols', 'max_forward_vol_ratio', 'event_detected'],
    properties: {
        base_vols: {
            type: 'array',
            items: {
                type: 'array',
                items: false,
                prefixItems: [
                    {
                        type: 'integer',
                        format: 'int32'
                    },
                    {
                        type: 'number',
                        format: 'double'
                    }
                ]
            }
        },
        event_detected: {
            type: 'boolean'
        },
        event_expiry_dte: {
            type: ['integer', 'null'],
            format: 'int32'
        },
        event_vols: {
            type: 'array',
            items: {
                type: 'array',
                items: false,
                prefixItems: [
                    {
                        type: 'integer',
                        format: 'int32'
                    },
                    {
                        type: 'number',
                        format: 'double'
                    }
                ]
            }
        },
        forward_vols: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ForwardVolPair'
            }
        },
        garch_params: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/GARCHParams'
                }
            ]
        },
        max_forward_vol_ratio: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $TermStructureBacktestSummary = {
    type: 'object',
    description: 'Top-level term-structure backtest summary.',
    required: ['slopes', 'curvatures'],
    properties: {
        curvatures: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CurvatureTripleSummary'
            }
        },
        slopes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SlopePairSummary'
            }
        }
    }
} as const;

export const $ThetaBound = {
    type: 'string',
    enum: ['positive', 'negative']
} as const;

export const $ThetaIncome = {
    type: 'object',
    required: ['daily', 'weekly', 'total_to_expiry', 'theta_instantaneous_daily', 'decay_to_expiry_cap'],
    properties: {
        daily: {
            type: 'number',
            format: 'double',
            description: `Reprice-based decay over 1 calendar day, bounded by extrinsic value
by construction (Item 6 / P1). See \`strategy::leg::reprice_decay\`.`
        },
        decay_to_expiry_cap: {
            type: 'number',
            format: 'double',
            description: `Explicit alias of \`total_to_expiry\`, added per the Item 6 ticket's
literal JSON field-name request.`
        },
        theta_instantaneous_daily: {
            type: 'number',
            format: 'double',
            description: `Raw linear-derivative daily theta (\`abs(net_theta) / 365 * 100\`),
the pre-Item-6 convention — kept for consumers who explicitly want
the instantaneous rate rather than a bounded horizon projection.
UNBOUNDED: unlike \`daily\`, this can exceed remaining extrinsic value
for short-dated positions; do not use it for a "safe to collect"
projection.`
        },
        total_to_expiry: {
            type: 'number',
            format: 'double',
            description: `Reprice-based decay over the full DTE, i.e. the position's total
extrinsic value — identical to \`decay_to_expiry_cap\` below, kept
under its original name for display-layer compatibility.`
        },
        weekly: {
            type: 'number',
            format: 'double',
            description: `Reprice-based decay over \`strategy::leg::WEEKLY_DECAY_HORIZON_DAYS\`
(7 calendar days), bounded by extrinsic value by construction.`
        }
    }
} as const;

export const $ToolCall = {
    type: 'object',
    required: ['function', 'id', 'index', 'type'],
    properties: {
        function: {
            '$ref': '#/components/schemas/ToolCallFunction'
        },
        id: {
            type: 'string'
        },
        index: {
            type: 'integer',
            format: 'int32'
        },
        type: {
            type: 'string'
        }
    }
} as const;

export const $ToolCallFunction = {
    type: 'object',
    required: ['name', 'arguments'],
    properties: {
        arguments: {},
        name: {
            type: 'string'
        }
    }
} as const;

export const $Trend = {
    type: 'string',
    description: 'Realized volatility trend.',
    enum: ['rising', 'falling', 'stable']
} as const;

export const $UnderlyingHighlight = {
    type: 'object',
    required: ['underlying', 'val'],
    properties: {
        underlying: {
            type: 'string'
        },
        val: {
            type: 'number',
            format: 'double'
        }
    }
} as const;

export const $VRPRegime = {
    type: 'string',
    description: 'VRP regime classification based on ratio of implied to realized vol.',
    enum: ['extreme_fear', 'fear', 'normal', 'complacency']
} as const;

export const $VRPTermStructure = {
    type: 'object',
    description: 'Full VRP term structure result.',
    required: ['tenors', 'richest_dte', 'cheapest_dte', 'vrp_rank', 'rolling_window_days'],
    properties: {
        cheapest_dte: {
            type: 'integer',
            format: 'int32'
        },
        richest_dte: {
            type: 'integer',
            format: 'int32'
        },
        rolling_window_days: {
            type: 'integer',
            format: 'int32',
            description: `Number of calendar days in the rolling window used for rank computation.
Zero if ranks were not computed (insufficient data).`
        },
        tenors: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TenorVRP'
            }
        },
        vrp_rank: {
            type: 'number',
            format: 'double',
            description: 'Aggregate VRP percentile vs rolling VRP history.'
        }
    }
} as const;

export const $View = {
    type: 'object',
    description: `The user's directional view: a target spot price at a horizon. This is
the single source of directional truth for strike selection, repricing,
and ranking.`,
    required: ['target_spot', 'horizon_days', 'direction', 'implied_move_1sigma'],
    properties: {
        direction: {
            '$ref': '#/components/schemas/Direction',
            description: `Direction derived from \`target_spot\` vs. the current spot, dead-banded.
NOT taken from \`MoviefoneInput.direction\` directly — that field (or the
CLI/HTTP \`direction\` param) is an override applied only when this
derived value is \`Neutral\` (see \`View::with_direction_override\`).`
        },
        horizon_days: {
            type: 'integer',
            format: 'int32',
            description: 'Days ahead the target is expected to be realized.'
        },
        implied_move_1sigma: {
            type: 'number',
            format: 'double',
            description: `1-sigma dollar move implied by ATM/forward IV over \`horizon_days\`, as
passed into \`View::new\`. Retained (not just consumed for the direction
dead band) so \`stress_wing_spots\` can floor a degenerate/neutral
\`move_dollars\` at a real displacement -- see AUD26-SE09 Fail 2.`
        },
        target_spot: {
            type: 'number',
            format: 'double',
            description: 'Spot price the user expects at `horizon_days`.'
        }
    }
} as const;

export const $ViewPnl = {
    type: 'object',
    description: `Per-candidate P&L under the user's view, computed by repricing every leg
at the view's target/horizon on the same projected surface the scenario
engine already builds (CLOCK-01 reprice-based decay, not theta*days).`,
    required: ['view_pnl', 'view_pnl_band_low', 'view_pnl_band_high', 'adverse_unchanged_pnl', 'adverse_reverse_pnl', 'stress_wing_down_pnl', 'stress_wing_up_pnl'],
    properties: {
        adverse_reverse_pnl: {
            type: 'number',
            format: 'double',
            description: `P&L if spot moves the same magnitude the OTHER direction at
horizon_days (view wrong, opposite move).`
        },
        adverse_unchanged_pnl: {
            type: 'number',
            format: 'double',
            description: 'P&L if spot is unchanged at horizon_days (view wrong, no move).'
        },
        pop_unavailable_reason: {
            type: ['string', 'null'],
            description: `Human-readable reason \`pop_view\` is \`None\`. Always \`Some\` exactly
when \`pop_view\` is \`None\`, and always \`None\` exactly when \`pop_view\`
is \`Some\`.`
        },
        pop_view: {
            type: ['number', 'null'],
            format: 'double',
            description: `P(view path finishes past this strategy's effective breakeven(s)),
computed from a lognormal distribution centered on target_spot with
the projected ATM IV at horizon_days -- NOT delta-based. 0-100 scale
to match the existing \`pop\` field's convention. \`None\` when
unsupported/degenerate -- see \`pop_unavailable_reason\`. NEVER
coerce this to a number when \`None\`.`
        },
        stress_wing_down_pnl: {
            type: 'number',
            format: 'double',
            description: `P&L at \`spot - w\` where \`w\` is the view's two-sided stress
displacement (see \`View::stress_wing_spots\`) -- floored at the
1-sigma implied move so a neutral/degenerate view still exercises a
genuine downward away-from-strike scenario. AUD26-SE09 Fail 2.`
        },
        stress_wing_up_pnl: {
            type: 'number',
            format: 'double',
            description: 'P&L at `spot + w`, the upward counterpart of `stress_wing_down_pnl`.'
        },
        view_pnl: {
            type: 'number',
            format: 'double',
            description: 'P&L if the view is realized exactly (spot = target_spot at horizon_days).'
        },
        view_pnl_band_high: {
            type: 'number',
            format: 'double',
            description: 'P&L at the upper band edge (spot + (1 + VIEW_BAND_FRACTION)*move).'
        },
        view_pnl_band_low: {
            type: 'number',
            format: 'double',
            description: 'P&L at the lower band edge (spot + (1 - VIEW_BAND_FRACTION)*move).'
        }
    }
} as const;

export const $ViewSpec = {
    type: 'object',
    properties: {
        horizon_days: {
            type: ['integer', 'null'],
            format: 'int32',
            description: 'number of days into future at which the user expects their price target to be hit.'
        },
        pin_strike: {
            type: ['number', 'null'],
            format: 'double'
        },
        pin_width: {
            type: ['number', 'null'],
            format: 'double'
        },
        stock_direction: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/StockDirection'
                }
            ]
        },
        target_pct: {
            type: ['number', 'null'],
            format: 'double'
        },
        target_spot: {
            type: ['number', 'null'],
            format: 'double'
        },
        vol_direction: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/VolDirection'
                }
            ]
        }
    }
} as const;

export const $VixQuote = {
    allOf: [
        {
            '$ref': '#/components/schemas/SymbolCandle'
        },
        {
            type: 'object',
            required: ['expiration_date'],
            properties: {
                expiration_date: {
                    type: 'string',
                    format: 'date'
                }
            }
        }
    ]
} as const;

export const $VolDirection = {
    type: 'string',
    enum: ['long', 'short', 'none']
} as const;

export const $VolForecastResult = {
    type: 'object',
    description: 'Vol forecast result.',
    properties: {
        ensemble_forecast: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ForecastWithCI'
                }
            ]
        },
        garch_forecast_10d: {
            type: ['number', 'null'],
            format: 'double'
        },
        garch_persistence: {
            type: ['number', 'null'],
            format: 'double'
        },
        har_forecast_5d: {
            type: ['number', 'null'],
            format: 'double'
        },
        har_r_squared: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $VolScannerRsp = {
    type: 'object',
    required: ['report_date', 'symbols'],
    properties: {
        report_date: {
            type: 'string',
            format: 'date'
        },
        symbols: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/OpeningSetupVolScanner'
            }
        }
    }
} as const;

export const $VolatilityRegime = {
    type: 'string',
    description: 'Volatility regime types',
    enum: ['StickyStrike', 'StickyDeltaMoneyness', 'StickyImpliedTree', 'ReverseSkew', 'Uncertain', 'InsufficientData']
} as const;

export const $VolatilitySnapshot = {
    type: 'object',
    description: 'Volatility snapshot for analysis results.',
    required: ['atm_iv_7d', 'atm_iv_30d', 'atm_iv_90d', 'forward_30d', 'realized_vol', 'surface_quality', 'skew_25d_30d', 'blend_weight', 'expirations', 'all_forward_vols'],
    properties: {
        all_forward_vols: {
            type: 'array',
            items: {
                type: 'array',
                items: false,
                prefixItems: [
                    {
                        type: 'integer',
                        format: 'int32'
                    },
                    {
                        type: 'integer',
                        format: 'int32'
                    },
                    {
                        type: 'number',
                        format: 'double'
                    }
                ]
            }
        },
        atm_iv_30d: {
            type: 'number',
            format: 'double'
        },
        atm_iv_7d: {
            type: 'number',
            format: 'double'
        },
        atm_iv_90d: {
            type: 'number',
            format: 'double'
        },
        blend_weight: {
            type: 'number',
            format: 'double'
        },
        carry_quality: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/CarryQuality'
                }
            ]
        },
        event_signal: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/EventSignal'
                }
            ]
        },
        expirations: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ExpirationSummary'
            }
        },
        forward_30d: {
            type: 'number',
            format: 'double'
        },
        forward_vol: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/ForwardVol'
                }
            ]
        },
        iv_rank: {
            type: ['number', 'null'],
            format: 'double'
        },
        realized_vol: {
            '$ref': '#/components/schemas/RealizedVol'
        },
        rv_estimators: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/RVEstimatorResult'
                }
            ]
        },
        skew_25d_30d: {
            type: 'number',
            format: 'double'
        },
        surface_quality: {
            '$ref': '#/components/schemas/ArbitrageQuality'
        },
        term_structure: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/TermStructureAnalysis'
                }
            ]
        },
        vt_forward_vol: {
            type: ['number', 'null'],
            format: 'double'
        }
    }
} as const;

export const $VolatilitySurface3D = {
    type: 'object',
    description: '3D volatility surface for frontend visualization.',
    required: ['expirations'],
    properties: {
        expirations: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/VolatilitySurfaceExpiration'
            }
        }
    }
} as const;

export const $VolatilitySurfaceExpiration = {
    type: 'object',
    description: 'Volatility surface expiration for 3D visualization.',
    required: ['date', 'dte', 'strikes', 'ivs', 'fwd', 'atm_iv'],
    properties: {
        atm_iv: {
            type: 'number',
            format: 'double'
        },
        date: {
            type: 'string'
        },
        dte: {
            type: 'integer',
            format: 'int32'
        },
        fwd: {
            type: 'number',
            format: 'double'
        },
        ivs: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        },
        strikes: {
            type: 'array',
            items: {
                type: 'number',
                format: 'double'
            }
        }
    }
} as const;

export const $WidthBound = {
    type: 'object',
    properties: {
        max: {
            type: ['number', 'null'],
            format: 'double'
        },
        min: {
            type: ['number', 'null'],
            format: 'double'
        },
        unit: {
            oneOf: [
                {
                    type: 'null'
                },
                {
                    '$ref': '#/components/schemas/WidthUnit'
                }
            ]
        }
    }
} as const;

export const $WidthUnit = {
    type: 'string',
    enum: ['points', 'strikes', 'pct']
} as const;